(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apple-style-contact"] && !Shopify.designMode) return;
  try {
    
// Set placeholders immediately to prevent Safari modification
(function() {
  // Force top and prevent auto scroll jumps if success is present
  try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
  var successNow = document.querySelector('.apple-contact-form__success');
  if (successNow) {
    // Clear any hash that could cause anchor jumps
    try { if (location.hash) { history.replaceState(null, '', location.pathname + location.search); } } catch (e) {}
    // Disable scrolling and snap to top immediately
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.style.overflowAnchor = 'none';
    document.body.classList.add('form-success-showing');
    // Keep page scrollable so footer is accessible
    document.body.style.overflow = '';
  }
  const inputs = document.querySelectorAll('.apple-contact-form__input:not([type="hidden"])');
  inputs.forEach(input => {
    if (input.tagName !== 'SELECT') {
      input.placeholder = ' ';
    }
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  const inputs = document.querySelectorAll('.apple-contact-form__input');
  const form = document.querySelector('.apple-contact-form__form');
  const submitButton = document.getElementById('submit-button');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    const root = document.querySelector('.apple-contact-form');
    if (root) root.classList.add('is-safari');
  }
  // (reverted) do not add initializing flag

  // Comprehensive form diagnostics
  function runFormDiagnostics() {
    console.group('🔧 APPLE CONTACT FORM DIAGNOSTICS');
    
    // Check if form exists
    if (!form) {
      console.error('❌ Form element not found!');
      return false;
    }
    console.log('✅ Form element found');
    
    // Check form attributes
    console.log('📋 Form attributes:');
    console.log('  - Action:', form.action || 'Not set');
    console.log('  - Method:', form.method || 'Not set');
    console.log('  - Target:', form.target || 'Not set');
    console.log('  - Enctype:', form.enctype || 'Not set');
    
    // Check if form is a Shopify contact form
    if (form.action.includes('/contact') || form.action.includes('contact')) {
      console.log('✅ Form appears to be a Shopify contact form');
    } else {
      console.warn('⚠️ Form action does not appear to be a Shopify contact form');
      console.log('  Expected: /contact or contains "contact"');
      console.log('  Actual:', form.action);
    }
    
    // Check required fields exist
    const requiredFields = ['contact[name]', 'contact[email]', 'contact[topic]', 'contact[body]'];
    requiredFields.forEach(fieldName => {
      const field = form.querySelector(`[name="${fieldName}"]`);
      if (field) {
        console.log(`✅ Required field found: ${fieldName}`);
      } else {
        console.error(`❌ Required field missing: ${fieldName}`);
      }
    });
    
    // Check submit button
    if (submitButton) {
      console.log('✅ Submit button found');
      console.log('  - Type:', submitButton.type);
      console.log('  - Disabled:', submitButton.disabled);
    } else {
      console.error('❌ Submit button not found!');
    }
    
    console.groupEnd();
    return true;
  }
  
  // Check if this is a success page (form was submitted)
  if (window.location.href.includes('contact_posted=true')) {
    console.log('🎉 SUCCESS PAGE DETECTED - Form was submitted successfully!');
    console.log('📧 Check your email for the contact form submission');
    
    // Check which email the form was sent to
    console.group('📧 EMAIL DESTINATION CHECK');
    console.log('🔍 Checking form submission details...');
    
    // Try to get form data from URL parameters or session storage
    const urlParams = new URLSearchParams(window.location.search);
    console.log('📋 URL Parameters:', Object.fromEntries(urlParams.entries()));
    
    // Check if we can determine the email destination
    console.log('🏪 Shopify Contact Form Info:');
    console.log('  - Form Action:', form ? form.action : 'Form not found');
    console.log('  - Form Method:', form ? form.method : 'Form not found');
    console.log('  - Current Domain:', window.location.hostname);
    
    // Check for any stored form data
    try {
      const storedData = sessionStorage.getItem('contact_form_data');
      if (storedData) {
        console.log('💾 Stored form data:', JSON.parse(storedData));
      }
    } catch (e) {
      console.log('ℹ️ No stored form data found');
    }
    
    console.log('📬 IMPORTANT: Check your Shopify admin for email settings:');
    console.log('   1. Go to Shopify Admin → Settings → Notifications');
    console.log('   2. Look for "Customer notifications" section');
    console.log('   3. Check "Contact form" notifications');
    console.log('   4. Verify the email address is correct');
    console.log('   5. Check spam/junk folder');
    
    console.groupEnd();
    
    // Disable form validation on success page
    if (form) {
      form.style.display = 'none';
    }
    
    // Show success message immediately
    const successMessage = document.querySelector('.apple-contact-form__success');
    if (successMessage) {
      successMessage.style.display = 'flex';
      successMessage.style.visibility = 'visible';
      successMessage.style.opacity = '1';
    }
    
    return; // Exit early on success page
  }

  // Run diagnostics on page load
  runFormDiagnostics();

  // Check if success message is present and disable animations immediately
  const successMessage = document.querySelector('.apple-contact-form__success');
  if (successMessage) {
    // Add class to HTML element to disable all animations
    document.documentElement.classList.add('disable-all-animations');
    document.body.classList.add('disable-all-animations');
    // Add Safari-compatible class to body
    document.body.classList.add('form-success-showing');
    
    // Disable any view transitions that might be active
    const mainEl = document.querySelector('main.content-for-layout');
    if (mainEl) {
      mainEl.setAttribute('data-page-transition-enabled', 'false');
      mainEl.style.viewTransitionName = 'none';
      mainEl.style.animation = 'none';
      mainEl.style.transition = 'none';
    }
    
    // Force reflow to ensure styles are applied immediately
    void document.body.offsetHeight;
    
    // Clear the session storage flag
    try {
      sessionStorage.removeItem('vt_disable_next');
    } catch (e) {}
    
    // Inject style to override all animations with more specificity
    const styleEl = document.createElement('style');
    styleEl.textContent = `
      body.form-success-showing * {
        animation: none !important;
        transition: none !important;
        animation-duration: 0s !important;
        transition-duration: 0s !important;
        transform: none !important;
      }
      body.form-success-showing ::view-transition-old(*),
      body.form-success-showing ::view-transition-new(*),
      body.form-success-showing ::view-transition-group(*),
      body.form-success-showing ::view-transition-image-pair(*) {
        animation: none !important;
        animation-duration: 0s !important;
      }
      body.form-success-showing main[data-page-transition-enabled="true"] {
        view-transition-name: none !important;
      }
      body.form-success-showing .apple-contact-form,
      body.form-success-showing .apple-contact-form__container,
      body.form-success-showing .apple-contact-form__form,
      body.form-success-showing .apple-contact-form__success {
        animation: none !important;
        transition: none !important;
        transform: none !important;
    display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding-top: 0 !important;
        min-height: 90vh !important;
        box-sizing: border-box;       
         }
        @media (max-width: 769px) {
  body.form-success-showing .apple-contact-form,
  body.form-success-showing .apple-contact-form__container,
  body.form-success-showing .apple-contact-form__form,
  body.form-success-showing .apple-contact-form__success {
    animation: none !important;
    transition: none !important;
    transform: none !important;
         display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        padding-top: 0 !important;
        min-height: 80vh !important;
        box-sizing: border-box;  
        }
}

    `;
    document.head.appendChild(styleEl);

    // Prevent any automatic scroll restoration; force top position
    try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
  
  inputs.forEach(input => {
    // Set placeholder to empty to prevent default browser behavior
    if (input.type !== 'hidden' && input.tagName !== 'SELECT') {
      input.setAttribute('placeholder', ' ');
    }
    
    // Handle focus events
    input.addEventListener('focus', function() {
      this.parentElement.classList.add('focused');
      // Remove error state on focus
      this.classList.remove('error');
    });
    
    // Handle blur events
    input.addEventListener('blur', function() {
      if (!this.value) {
        this.parentElement.classList.remove('focused');
      }
    });

    // For SELECT, some mobile browsers don't trigger :focus before opening picker
    // Simulate focus to animate the label when the user taps the field
    if (input.tagName === 'SELECT') {
      const addFocus = function() { this.parentElement.classList.add('focused'); };
      input.addEventListener('pointerdown', addFocus, { passive: true });
      input.addEventListener('touchstart', addFocus, { passive: true });
      input.addEventListener('mousedown', addFocus);
    }
    
    // Handle input events for real-time validation
    input.addEventListener('input', function() {
      this.parentElement.classList.toggle('has-value', !!this.value);
      // Clear error immediately when user starts typing/selecting
      if (this.value && this.value.trim()) {
        this.classList.remove('error');
        this.style.borderColor = '#d2d2d7';
        this.style.backgroundColor = '#ffffff';
        const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
        if (errorMsg) errorMsg.style.display = 'none';
      }
    });
    
    // Handle change events (with special case for SELECT)
    input.addEventListener('change', function() {
      if (this.tagName === 'SELECT') {
        const isPlaceholderSelected = this.selectedIndex === 0 && this.options[0] && this.options[0].value === '';
        this.parentElement.classList.toggle('has-value', this.selectedIndex > 0 && !isPlaceholderSelected);
        // Picker closed; remove temporary focus state
        this.parentElement.classList.remove('focused');
        
        // Clear error immediately when a valid option is selected
        if (this.selectedIndex > 0 && !isPlaceholderSelected) {
          this.classList.remove('error');
          this.style.borderColor = '#d2d2d7';
          this.style.backgroundColor = '#ffffff';
          const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
          if (errorMsg) errorMsg.style.display = 'none';
        }
      } else {
        this.parentElement.classList.toggle('has-value', !!this.value);
      }
    });
    
    // Initialize state
    if (input.tagName === 'SELECT') {
      const hasPreselected = !!input.querySelector('option[selected]');
      if (!hasPreselected) {
        // If first option is empty placeholder, keep at 0; otherwise unset
        if (input.options.length && input.options[0].value === '') {
          input.selectedIndex = 0;
        } else {
          input.selectedIndex = -1;
        }
      }
      const isPlaceholderSelected = input.selectedIndex === 0 && input.options[0] && input.options[0].value === '';
      input.parentElement.classList.toggle('has-value', input.selectedIndex > 0 && !isPlaceholderSelected);
    } else {
      if (input.value && input.value !== '') {
        input.parentElement.classList.add('has-value');
      }
    }
  });

  // Removed Safari-forced custom dropdown to use native select while preserving design/flow
  
  // Email validation function
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Validate form fields
  function validateForm() {
    const requiredFields = form.querySelectorAll('[required]');
    let isValid = true;
    
    requiredFields.forEach(field => {
      const errorMsg = field.parentElement.querySelector('.apple-contact-form__error-message');
      
      // Check if field is empty
      if (!field.value.trim() || (field.tagName === 'SELECT' && (field.selectedIndex <= 0 || (field.selectedIndex === 0 && field.options[0] && field.options[0].value === '')))) {
        field.style.borderColor = '#FF3B30';
        field.style.backgroundColor = '#FFF5F5';
        field.classList.add('error');
        if (field.tagName === 'SELECT') {
          const custom = field.parentElement.querySelector('.custom-select');
          if (custom) custom.classList.add('error');
        }
        if (errorMsg) {
          errorMsg.style.display = 'flex';
        }
        isValid = false;
      } 
      // Check email validation for email fields
      else if (field.type === 'email' && !validateEmail(field.value.trim())) {
        field.style.borderColor = '#FF3B30';
        field.style.backgroundColor = '#FFF5F5';
        field.classList.add('error');
        if (errorMsg) {
          errorMsg.style.display = 'flex';
        }
        isValid = false;
      }
      else {
        field.style.borderColor = '#d2d2d7';
        field.style.backgroundColor = '#ffffff';
        field.classList.remove('error');
        if (field.tagName === 'SELECT') {
          const custom = field.parentElement.querySelector('.custom-select');
          if (custom) custom.classList.remove('error');
        }
        if (errorMsg) {
          errorMsg.style.display = 'none';
        }
      }
    });
    
    return isValid;
  }

  // Real-time validation on blur
  inputs.forEach(input => {
    // Remove HTML5 validation
    input.addEventListener('invalid', function(e) {
      e.preventDefault();
    });
    
    input.addEventListener('blur', function() {
      const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
      
      if (this.hasAttribute('required')) {
        const isEmpty = this.tagName === 'SELECT' ? (this.selectedIndex <= 0 || (this.selectedIndex === 0 && this.options[0] && this.options[0].value === '')) : !this.value.trim();
        if (isEmpty) {
          this.style.borderColor = '#FF3B30';
          this.style.backgroundColor = '#FFF5F5';
          this.classList.add('error');
          if (this.tagName === 'SELECT') {
            const custom = this.parentElement.querySelector('.custom-select');
            if (custom) custom.classList.add('error');
          }
          if (errorMsg) {
            errorMsg.style.display = 'flex';
          }
        } else if (this.type === 'email' && !validateEmail(this.value.trim())) {
          this.style.borderColor = '#FF3B30';
          this.style.backgroundColor = '#FFF5F5';
          this.classList.add('error');
          if (this.tagName === 'SELECT') {
            const custom = this.parentElement.querySelector('.custom-select');
            if (custom) custom.classList.add('error');
          }
          if (errorMsg) {
            errorMsg.style.display = 'flex';
          }
        } else {
          this.style.borderColor = '#d2d2d7';
          this.style.backgroundColor = '#ffffff';
          this.classList.remove('error');
          if (this.tagName === 'SELECT') {
            const custom = this.parentElement.querySelector('.custom-select');
            if (custom) custom.classList.remove('error');
          }
          if (errorMsg) {
            errorMsg.style.display = 'none';
          }
        }
      }
    });
  });

  // Handle form submission with loading state
  if (form && submitButton) {
    // Disable HTML5 validation
    form.setAttribute('novalidate', 'true');
    
    let submitting = false;
    
    // Enhanced debugging function
    function debugFormSubmission(formData, error = null) {
      console.group('🔍 APPLE CONTACT FORM DEBUG INFO');
      console.log('📧 Form Type: General Contact Form');
      console.log('⏰ Timestamp:', new Date().toISOString());
      console.log('🌐 Current URL:', window.location.href);
      console.log('📱 User Agent:', navigator.userAgent);
      
      if (error) {
        console.error('❌ ERROR:', error);
      }
      
      console.log('📋 Form Data:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      // Check for required fields
      const requiredFields = ['contact[name]', 'contact[email]', 'contact[topic]', 'contact[body]'];
      const missingFields = [];
      requiredFields.forEach(field => {
        if (!formData.get(field) || formData.get(field).trim() === '') {
          missingFields.push(field);
        }
      });
      
      if (missingFields.length > 0) {
        console.warn('⚠️ Missing required fields:', missingFields);
      } else {
        console.log('✅ All required fields present');
      }
      
      // Check email format
      const email = formData.get('contact[email]');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email && !emailRegex.test(email)) {
        console.warn('⚠️ Invalid email format:', email);
      } else if (email) {
        console.log('✅ Email format valid:', email);
      }
      
      console.groupEnd();
    }
    
    // Block reCAPTCHA or any click-based handlers when invalid
    submitButton.addEventListener('click', function(e){
      console.log('🖱️ Submit button clicked');
      if (!validateForm()) {
        console.warn('❌ Form validation failed on click');
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      console.log('✅ Form validation passed on click');
    });
    
    form.addEventListener('submit', function(e) {
      console.log('📤 Form submit event triggered');
      
      if (submitting) { 
        console.warn('⚠️ Form already submitting, preventing duplicate submission');
        e.preventDefault(); 
        return false; 
      }
      
      // Validate form before submission
      if (!validateForm()) {
        console.error('❌ Form validation failed on submit');
        // Prevent submission if validation fails
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      console.log('✅ Form validation passed, proceeding with submission');
      
      // Check if this is a reCAPTCHA reload (URL contains contact_posted=true)
      if (window.location.href.includes('contact_posted=true')) {
        console.log('🔄 Detected reCAPTCHA reload - form was already submitted');
        return; // Let the page show success message
      }
      
      // Disable page view transitions for this navigation (Thank You)
      const mainEl = document.querySelector('main.content-for-layout');
      if (mainEl) mainEl.setAttribute('data-page-transition-enabled', 'false');
      try { sessionStorage.setItem('vt_disable_next', '1'); } catch (e) {
        console.warn('⚠️ Could not set session storage:', e);
      }
      
      const submitText = submitButton.querySelector('.submit-text');
      const submitLoading = submitButton.querySelector('.submit-loading');
      
      // Show loading state
      submitting = true;
      submitButton.disabled = true;
      if (submitText) submitText.style.display = 'none';
      if (submitLoading) submitLoading.style.display = 'inline-block';
      submitButton.classList.add('loading');
      
      // Lock the scroll position and ensure we're at top while navigating
      try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Prevent scroll during the transition to success
      // Keep page scrollable so footer remains visible
      document.body.style.overflow = '';
      
      // Debug form submission
      const formData = new FormData(form);
      debugFormSubmission(formData);
      
      // Store form data for debugging
      try {
        const formDataObj = {};
        for (let [key, value] of formData.entries()) {
          formDataObj[key] = value;
        }
        sessionStorage.setItem('contact_form_data', JSON.stringify(formDataObj));
        console.log('💾 Form data stored for debugging');
      } catch (e) {
        console.warn('⚠️ Could not store form data:', e);
      }
      
      // Check if form action is correct
      console.log('🔗 Form action:', form.action);
      console.log('📝 Form method:', form.method);
      console.log('🎯 Form target:', form.target);
      
      // Log the email address being used
      const emailField = form.querySelector('input[name="contact[email]"]');
      if (emailField) {
        console.log('📧 Form will be sent to:', emailField.value);
      }
      
      // Add error handling for form submission
      form.addEventListener('error', function(e) {
        console.error('❌ Form submission error:', e);
        debugFormSubmission(new FormData(form), e);
      });
      
      // Monitor for any JavaScript errors during submission
      window.addEventListener('error', function(e) {
        console.error('❌ JavaScript error during form submission:', e);
      });
      
      console.log('📧 Form should now send email to registered address');
      console.log('💡 Check your Shopify admin → Settings → Notifications for email settings');
      console.log('📬 Check spam/junk folder for emails from Shopify');
      
      // Add global test function for manual testing
      window.testAppleContactForm = function() {
        console.log('🧪 MANUAL APPLE CONTACT FORM TEST');
        runFormDiagnostics();
        debugFormSubmission(new FormData(form));
        
        // Test form submission without actually submitting
        console.log('🔍 Testing form data collection...');
        const testData = new FormData(form);
        console.log('📊 Test data collected successfully');
        
        // Check if all required data is present
        const hasName = testData.get('contact[name]');
        const hasEmail = testData.get('contact[email]');
        const hasTopic = testData.get('contact[topic]');
        const hasBody = testData.get('contact[body]');
        
        if (hasName && hasEmail && hasTopic && hasBody) {
          console.log('✅ All test data present - form should work');
        } else {
          console.warn('⚠️ Missing test data - fill out form first');
        }
      };
      
      console.log('💡 Run window.testAppleContactForm() in console to test form manually');
      
      // Add email delivery test function
      window.testEmailDelivery = function() {
        console.group('🧪 EMAIL DELIVERY TEST');
        console.log('📧 Testing email delivery configuration...');
        
        // Check if we can find any email configuration
        console.log('🔍 Checking form configuration:');
        console.log('  - Form action:', form.action);
        console.log('  - Form method:', form.method);
        console.log('  - Current domain:', window.location.hostname);
        
        // Check if this is a Shopify contact form
        if (form.action.includes('/contact')) {
          console.log('✅ Form is using Shopify contact endpoint');
          console.log('📬 Emails should be sent to your Shopify admin notification settings');
          console.log('🔧 To configure: Settings → Notifications → Customer notifications → Contact form');
        } else {
          console.warn('⚠️ Form action does not appear to be Shopify contact form');
        }
        
        console.log('📋 Troubleshooting checklist:');
        console.log('  1. ✅ Form submits successfully (confirmed)');
        console.log('  2. ❓ Contact form notifications enabled in Shopify admin');
        console.log('  3. ❓ Email address configured in notification settings');
        console.log('  4. ❓ Check spam/junk folder');
        console.log('  5. ❓ Try different email address (not role-based)');
        
        console.groupEnd();
      };
      
      console.log('💡 Run window.testEmailDelivery() to check email configuration');
      
      // Don't prevent default - let reCAPTCHA handle the submission
      console.log('🤖 Allowing reCAPTCHA to handle form submission');
    });
  }
  
  // Add subtle hover effects
  inputs.forEach(input => {
    input.addEventListener('mouseenter', function() {
      if (!this.matches(':focus') && !this.classList.contains('error')) {
        this.style.borderColor = '#666666';
        this.style.transform = 'translateY(-1px)';
      }
    });
    
    input.addEventListener('mouseleave', function() {
      if (!this.matches(':focus') && !this.classList.contains('error')) {
        this.style.borderColor = '#d2d2d7';
        this.style.transform = 'translateY(0)';
      }
    });
  });
  // (reverted) no initializing flag to remove
});

// Add this to your theme's global JS
document.addEventListener('DOMContentLoaded', function() {
  const successMsg = document.querySelector('.apple-contact-form__success');
  if (successMsg) {
    successMsg.style.animation = 'none';
    successMsg.style.transform = 'none';
    successMsg.style.opacity = '1';
  }
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apple-style-multi-steps-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Check if we have a form success flag from previous page load
    try {
      if (sessionStorage.getItem('form_success_showing') === '1') {
        document.body.classList.add('form-success-showing');
        sessionStorage.removeItem('form_success_showing');
      }
    } catch (e) {}
    
    const inputs = document.querySelectorAll('.apple-contact-form__input');
    const form = document.querySelector('.apple-contact-form__form');
    const submitButton = document.getElementById('submit-button');
    const stepContents = document.querySelectorAll('.step-content');
    const stepDots = document.querySelectorAll('.step-dot');
    const stepIndicator = document.querySelector('.step-indicator-vertical');
    const indicatorOriginalParent = stepIndicator ? stepIndicator.parentElement : null;
    const indicatorOriginalNextSibling = stepIndicator ? stepIndicator.nextSibling : null;
    const nextButtons = document.querySelectorAll('.next-step');
    const prevButtons = document.querySelectorAll('.prev-step');
    const root = document.querySelector('.apple-contact-form');
    const container = document.querySelector('.apple-contact-form__container');
    const titleEl = document.querySelector('.apple-contact-form__title');
    // Get translated step titles from data attributes
    const stepTitles = {};
    if (titleEl) {
      stepTitles[1] = titleEl.getAttribute('data-step-1') || 'Tell us about yourself.';
      stepTitles[2] = titleEl.getAttribute('data-step-2') || 'Tell us about your business.';
      stepTitles[3] = titleEl.getAttribute('data-step-3') || "Is there anything specific you'd like to discuss?";
    } else {
      // Fallback if titleEl is not found
      stepTitles[1] = 'Tell us about yourself.';
      stepTitles[2] = 'Tell us about your business.';
      stepTitles[3] = "Is there anything specific you'd like to discuss?";
    }

    // Check if success message is present and disable animations immediately
    const successMessage = document.querySelector('.apple-contact-form__success');
    if (successMessage) {
      // Prevent browser scroll restoration and anchor jumps
      try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
      try { if (location.hash) { history.replaceState(null, '', location.pathname + location.search); } } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Keep page scrollable so footer remains visible
      document.body.style.overflow = '';

      // Add class to body for Safari compatibility (instead of relying on :has())
      document.body.classList.add('form-success-showing');
      
      // Add class to HTML element to disable all animations
      document.documentElement.classList.add('disable-all-animations');
      document.body.classList.add('disable-all-animations');
      
      // Disable any view transitions that might be active
      const mainEl = document.querySelector('main.content-for-layout');
      if (mainEl) {
        mainEl.setAttribute('data-page-transition-enabled', 'false');
        mainEl.style.viewTransitionName = 'none';
        mainEl.style.animation = 'none';
        mainEl.style.transition = 'none';
      }
      
      // Force reflow to ensure styles are applied immediately
      void document.body.offsetHeight;
      
      // Clear the session storage flag
      try {
        sessionStorage.removeItem('vt_disable_next');
      } catch (e) {}
      
      // Inject style to override all animations with more specific selectors
      const styleEl = document.createElement('style');
      styleEl.textContent = `
        * {
          animation: none !important;
          transition: none !important;
          animation-duration: 0s !important;
          transition-duration: 0s !important;
          animation-delay: 0s !important;
          transition-delay: 0s !important;
        }
        ::view-transition-old(*),
        ::view-transition-new(*),
        ::view-transition-group(*),
        ::view-transition-image-pair(*) {
          animation: none !important;
          animation-duration: 0s !important;
        }
        body.form-success-showing * {
          animation: none !important;
          transition: none !important;
          transform: none !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
        .apple-contact-form__success,
        .apple-contact-form__success * {
          animation: none !important;
          transition: none !important;
          transform: none !important;

        }
      `;
      document.head.appendChild(styleEl);
    }

    let currentStep = 0;

    // (reverted) do not add initializing flag

    inputs.forEach((input) => {
      if (input.type !== 'hidden' && input.tagName !== 'SELECT') input.setAttribute('placeholder', ' ');
      input.addEventListener('focus', function () {
        this.parentElement.classList.add('focused');
        // Remove error state on focus
        this.classList.remove('error');
      });
      input.addEventListener('blur', function () {
        if (this.tagName === 'SELECT') {
          // For select elements, check selectedIndex instead of value
          if (this.selectedIndex <= 0) {
            this.parentElement.classList.remove('focused');
          }
        } else {
          // For other inputs, check value
          if (!this.value) this.parentElement.classList.remove('focused');
        }
      });

      if (input.tagName === 'SELECT') {
        const addFocus = function () {
          this.parentElement.classList.add('focused');
        };
        input.addEventListener('pointerdown', addFocus, { passive: true });
        input.addEventListener('touchstart', addFocus, { passive: true });
        input.addEventListener('mousedown', addFocus);
      }

      input.addEventListener('input', function () {
        this.parentElement.classList.toggle('has-value', !!this.value);
        // Clear error immediately when user starts typing/selecting
        if (this.value && this.value.trim()) {
          this.classList.remove('error');
          this.style.borderColor = '#d2d2d7';
          this.style.backgroundColor = '#ffffff';
          const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
          if (errorMsg) errorMsg.style.display = 'none';
        }
      });

      input.addEventListener('change', function () {
        if (this.tagName === 'SELECT') {
          this.parentElement.classList.toggle('has-value', this.selectedIndex > 0);
          // Only remove focused class if no value is selected
          if (this.selectedIndex <= 0) {
            this.parentElement.classList.remove('focused');
          }
          // Clear error immediately when a valid option is selected
          if (this.selectedIndex > 0) {
            this.classList.remove('error');
            this.style.borderColor = '#d2d2d7';
            this.style.backgroundColor = '#ffffff';
            const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
            if (errorMsg) errorMsg.style.display = 'none';
          }
        } else {
          this.parentElement.classList.toggle('has-value', !!this.value);
        }
      });

      if (input.tagName === 'SELECT') {
        const hasPreselected = !!input.querySelector('option[selected]');
        if (!hasPreselected) input.selectedIndex = -1;
        // Check if the selected option is the empty placeholder (first option with empty value)
        const isPlaceholderSelected = input.selectedIndex === 0 && input.options[0].value === '';
        input.parentElement.classList.toggle('has-value', input.selectedIndex > 0 && !isPlaceholderSelected);
      } else if (input.value) {
        input.parentElement.classList.add('has-value');
      }
    });


    function setTitle(stepNumber) {
      if (!titleEl) return;
      // Hide main title on intro step
      if (stepNumber === 0) {
        titleEl.style.display = 'none';
        return;
      }
      if (stepTitles[stepNumber]) {
        titleEl.textContent = stepTitles[stepNumber];
        titleEl.style.display = '';
      } else {
        titleEl.style.display = 'none';
      }
    }

    // Only target step contents and dots (not both) by scoping the selector
    function showStep(stepNumber) {
      stepContents.forEach((c) => c.classList.remove('active'));
      stepDots.forEach((d) => d.classList.remove('active'));

      const content = document.querySelector(`.step-content[data-step="${stepNumber}"]`);
      const dot = document.querySelector(`.step-dot[data-step="${stepNumber}"]`);
      if (content) content.classList.add('active');
      if (dot) dot.classList.add('active');

      currentStep = stepNumber;
      setTitle(stepNumber);

      const isWide = stepNumber === 2;
      if (root) root.classList.toggle('is-wide-step-2', isWide);
      if (container) container.classList.toggle('is-wide-step-2', isWide);

      // Reposition step indicator for mobile on each step change
      moveIndicatorForViewport();
    }

    // Clickable dots
    //stepDots.forEach((d) => d.addEventListener('click', () => showStep(parseInt(d.dataset.step, 10))));

    // Clickable dots (with validation)
    stepDots.forEach((d) =>
      d.addEventListener('click', () => {
        const targetStep = parseInt(d.dataset.step, 10);
        if (targetStep > currentStep) {
          // ✅ Forward navigation only if current step is valid
          if (validateCurrentStep()) {
            showStep(targetStep);
          }
        } else {
          // ✅ Always allow backward navigation
          showStep(targetStep);
        }
      })
    );

    // Buttons
    nextButtons.forEach((btn) => {
      if (btn.classList.contains('intro-start')) return; // handled separately to allow slide-up animation
      btn.addEventListener('click', function () {
        const nextStep = parseInt(this.dataset.next, 10);
        if (validateCurrentStep()) showStep(nextStep);
      });
    });
    prevButtons.forEach((btn) =>
      btn.addEventListener('click', function () {
        const prevStep = parseInt(this.dataset.prev, 10);
        showStep(prevStep);
      })
    );

    // Intro start button: play slide-up animation, then advance to step 1
    const introStartBtn = document.querySelector('.intro-start');
    if (introStartBtn) {
      introStartBtn.addEventListener('click', function () {
        // Intro has no required fields; just animate out and then move on
        const introContent = document.querySelector('.step-content[data-step="0"]');
        if (!introContent) { showStep(1); return; }
        if (introContent.classList.contains('slide-up-out')) return;
        introContent.classList.add('slide-up-out');
        const onEnd = () => {
          introContent.removeEventListener('animationend', onEnd);
          showStep(1);
          // Smooth entrance for step 1
          const step1 = document.querySelector('.step-content[data-step="1"]');
          if (step1) {
            step1.classList.add('animate-in');
            const clean = () => {
              step1.removeEventListener('animationend', clean);
              step1.classList.remove('animate-in');
            };
            step1.addEventListener('animationend', clean);
          }
        };
        introContent.addEventListener('animationend', onEnd);
        // Fallback in case animationend doesn't fire
        setTimeout(() => {
          if (currentStep === 0) {
            showStep(1);
            const step1 = document.querySelector('.step-content[data-step="1"]');
            if (step1) {
              step1.classList.add('animate-in');
              setTimeout(() => step1.classList.remove('animate-in'), 420);
            }
          }
        }, 400);
      });
    }

    function validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    function validateCurrentStep() {
      // Skip validation on intro
      if (currentStep === 0) return true;
      const currentStepContent = document.querySelector(`.step-content[data-step="${currentStep}"]`);
      if (!currentStepContent) return false;
      const requiredFields = currentStepContent.querySelectorAll('[required]');
      let isValid = true;
      let firstInvalidField = null;

      requiredFields.forEach((field) => {
        const errorMsg = field.parentElement.querySelector('.apple-contact-form__error-message');

        // Check if field is empty (including SELECT fields)
        const isEmpty =
          field.tagName === 'SELECT'
            ? field.selectedIndex <= 0 || !field.value || (field.selectedIndex === 0 && field.options[0].value === '')
            : !field.value.trim();

        if (isEmpty) {
          field.style.borderColor = '#FF3B30';
          field.style.backgroundColor = '#FFF5F5';
          field.classList.add('error');
          if (errorMsg) {
            errorMsg.style.display = 'flex';
          }
          if (!firstInvalidField) firstInvalidField = field;
          isValid = false;
        }
        // Check email validation for email fields
        else if (field.type === 'email' && !validateEmail(field.value.trim())) {
          field.style.borderColor = '#FF3B30';
          field.style.backgroundColor = '#FFF5F5';
          field.classList.add('error');
          if (errorMsg) {
            errorMsg.style.display = 'flex';
          }
          if (!firstInvalidField) firstInvalidField = field;
          isValid = false;
        } else {
          field.style.borderColor = '#d2d2d7';
          field.style.backgroundColor = '#ffffff';
          field.classList.remove('error');
          if (errorMsg) {
            errorMsg.style.display = 'none';
          }
        }
      });
      // Focus and scroll to the first invalid field (good for mobile UX)
      if (!isValid && firstInvalidField) {
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          firstInvalidField.focus({ preventScroll: true });
        }, 150);
      }
      return isValid;
    }

    // Real-time validation on blur
    inputs.forEach((input) => {
      input.addEventListener('blur', function () {
        const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');

        if (this.hasAttribute('required')) {
          const isEmpty =
            this.tagName === 'SELECT'
              ? this.selectedIndex <= 0 || !this.value || (this.selectedIndex === 0 && this.options[0].value === '')
              : !this.value.trim();
          if (isEmpty) {
            this.style.borderColor = '#FF3B30';
            this.style.backgroundColor = '#FFF5F5';
            this.classList.add('error');
            if (errorMsg) {
              errorMsg.style.display = 'flex';
            }
          } else if (this.type === 'email' && !validateEmail(this.value.trim())) {
            this.style.borderColor = '#FF3B30';
            this.style.backgroundColor = '#FFF5F5';
            this.classList.add('error');
            if (errorMsg) {
              errorMsg.style.display = 'flex';
            }
          } else {
            this.style.borderColor = '#d2d2d7';
            this.style.backgroundColor = '#ffffff';
            this.classList.remove('error');
            if (errorMsg) {
              errorMsg.style.display = 'none';
            }
          }
        }
      });
    });

    // Start on step 1
    // Initialize: show thank-you (step 4) if already posted, else start at step 1
    // const thankYouActive = document.querySelector('.step-content[data-step="4"].active');
    // if (thankYouActive) {
    //   // hide title and select dot 4
    //   if (titleEl) titleEl.style.display = 'none';
    //   stepDots.forEach((d) => d.classList.remove('active'));
    //   const dot4 = document.querySelector('.step-dot[data-step="4"]');
    //   if (dot4) dot4.classList.add('active');

    //   // make sure wide layout is not forced on thank-you
    //   if (root) root.classList.remove('is-wide-step-2');
    //   if (container) container.classList.remove('is-wide-step-2');
    // } else {
    //   showStep(1);
    // }

    // if (form && submitButton) {
    //   form.addEventListener('submit', function () {
    //     const submitText = submitButton.querySelector('.submit-text');
    //     const submitLoading = submitButton.querySelector('.submit-loading');
    //     submitButton.disabled = true;
    //     if (submitText) submitText.style.display = 'none';
    //     if (submitLoading) submitLoading.style.display = 'inline-block';
    //     submitButton.classList.add('loading');
    //   });
    // }

    // Ensure page view transition is disabled on submit to Thank You
    if (form && submitButton) {
      form.addEventListener('submit', function () {
        // Immediately hide the textarea field to avoid a brief flash
        form.classList.add('is-submitting');
        // Add body class for Safari compatibility
        document.body.classList.add('form-success-showing');
        // Lock scroll at top during navigation
        try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        // Keep page scrollable so footer remains visible
        document.body.style.overflow = '';
        
        const mainEl = document.querySelector('main.content-for-layout');
        if (mainEl) {
          mainEl.setAttribute('data-page-transition-enabled', 'false');
          mainEl.style.viewTransitionName = 'none';
          mainEl.style.animation = 'none';
          mainEl.style.transition = 'none';
        }
        
        try { 
          sessionStorage.setItem('vt_disable_next','1'); 
          // Also store flag that we're showing success
          sessionStorage.setItem('form_success_showing','1');
        } catch(e) {}
        
        // Show loading state
        const submitText = submitButton.querySelector('.submit-text');
        const submitLoading = submitButton.querySelector('.submit-loading');
        submitButton.disabled = true;
        if (submitText) submitText.style.display = 'none';
        if (submitLoading) submitLoading.style.display = 'inline-block';
        submitButton.classList.add('loading');
      });
    }
    // (reverted) no initializing flag to remove

    // Start on step 1
    // Initialize: show thank-you (step 4) if already posted, else start at step 1
    const thankYouActive = document.querySelector('.step-content[data-step="4"].active');
    if (thankYouActive) {
      // hide title and select dot 4
      if (titleEl) titleEl.style.display = 'none';
      stepDots.forEach((d) => d.classList.remove('active'));
      const dot4 = document.querySelector('.step-dot[data-step="4"]');
      if (dot4) dot4.classList.add('active');

      // make sure wide layout is not forced on thank-you
      if (root) root.classList.remove('is-wide-step-2');
      if (container) container.classList.remove('is-wide-step-2');

      // ✅ Hide vertical step indicator on thank-you step
      const stepIndicator = document.querySelector('.step-indicator-vertical');
      if (stepIndicator) stepIndicator.style.display = 'none';
    } else {
      // Initialize with intro step
      showStep(0);
    }

    // --- Mobile placement of step dots: below form, above buttons ---
    function debounce(fn, delay) {
      let t;
      return function () {
        clearTimeout(t);
        const args = arguments;
        t = setTimeout(() => fn.apply(null, args), delay);
      };
    }

    function moveIndicatorForViewport() {
      if (!stepIndicator) return;

      // Do not show indicator on thank-you (step 4)
      const isThankYouVisible = document.querySelector('.step-content[data-step="4"].active');
      if (isThankYouVisible) { stepIndicator.style.display = 'none'; return; }
      // Hide on intro step
      if (currentStep === 0) { stepIndicator.style.display = 'none'; return; }

      if (window.innerWidth <= 768) {
        const activeStep = document.querySelector('.step-content.active');
        if (!activeStep) return;

        // Prefer placing right after the step navigation buttons (below the Continue button)
        const stepNav = activeStep.querySelector('.step-navigation');
        if (stepNav && stepNav.parentElement) {
          stepNav.parentElement.insertBefore(stepIndicator, stepNav.nextSibling);
          stepIndicator.style.display = '';
          return;
        }

        // Fallback for step 1: place after the primary next button inside fields
        const fieldsWrap = activeStep.querySelector('.apple-contact-form__fields');
        if (fieldsWrap) {
          const nextBtn = fieldsWrap.querySelector('.next-step');
          if (nextBtn) {
            fieldsWrap.insertBefore(stepIndicator, nextBtn.nextSibling);
          } else {
            fieldsWrap.appendChild(stepIndicator);
          }
          stepIndicator.style.display = '';
        }
      } else if (indicatorOriginalParent) {
        // Restore to original position for desktop
        if (indicatorOriginalNextSibling && indicatorOriginalNextSibling.parentNode === indicatorOriginalParent) {
          indicatorOriginalParent.insertBefore(stepIndicator, indicatorOriginalNextSibling);
        } else {
          indicatorOriginalParent.insertBefore(stepIndicator, indicatorOriginalParent.firstChild);
        }
        stepIndicator.style.display = '';
      }
    }

    // Initial placement and on resize
    moveIndicatorForViewport();
    window.addEventListener('resize', debounce(moveIndicatorForViewport, 150));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-inquiry-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('BulkInquiryForm');
    const addItemBtn = document.getElementById('AddItemButton');
    const itemsContainer = document.getElementById('BulkItems');
    const submitBtn = document.getElementById('bulk-submit');


    // Check if success message is present and disable animations immediately
    const successMessage = document.querySelector('.apple-contact-form__success');
    if (successMessage) {
      // Prevent auto scroll jumps and keep page scrollable
      try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
      try { if (location.hash) { history.replaceState(null, '', location.pathname + location.search); } } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Add class to HTML element to disable all animations
      document.documentElement.classList.add('disable-all-animations');
      document.body.classList.add('disable-all-animations');
      // Add Safari-compatible class
      document.body.classList.add('form-success-showing');

      // Disable any view transitions that might be active
      const mainEl = document.querySelector('main.content-for-layout');
      if (mainEl) {
        mainEl.setAttribute('data-page-transition-enabled', 'false');
        mainEl.style.viewTransitionName = 'none';
        mainEl.style.animation = 'none';
        mainEl.style.transition = 'none';
      }

      // Force reflow to ensure styles are applied immediately
      void document.body.offsetHeight;

      // Clear the session storage flag
      try {
        sessionStorage.removeItem('vt_disable_next');
      } catch (e) {}

      // Inject style to override all animations
      const styleEl = document.createElement('style');
      styleEl.textContent = `
        * {
          animation: none !important;
          transition: none !important;
          animation-duration: 0s !important;
          transition-duration: 0s !important;
        }
        ::view-transition-old(*),
        ::view-transition-new(*) {
          animation: none !important;
        }
        .apple-contact-form,
        .apple-contact-form__container,
        .apple-contact-form__form,
        .apple-contact-form__success {
          animation: none !important;
          transition: none !important;
          transform: none !important;
          height: auto !important;
          min-height: auto !important;
          max-height: none !important;
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Detect Safari (not Chrome on iOS)
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Flag container for Safari-specific CSS tweaks
    if (isSafari) {
      const root = document.querySelector('.bulk-inquiry-form');
      if (root) root.classList.add('is-safari');
      
      // Global handler to close all dropdowns when clicking anywhere
      document.addEventListener('click', (e) => {
        // If click is not on a dropdown button or list, close all dropdowns
        const clickedOnDropdown = e.target.closest('.custom-select');
        const clickedOnButton = e.target.closest('.custom-select__button');
        
        if (!clickedOnButton) {
          // Close all open dropdowns
          document.querySelectorAll('.custom-select.is-open').forEach((openSelect) => {
            openSelect.classList.remove('is-open');
            const button = openSelect.querySelector('.custom-select__button');
            const list = openSelect.querySelector('.custom-select__list');
            if (button) button.setAttribute('aria-expanded', 'false');
            if (list) list.style.display = 'none';
          });
        }
      }, true); // Use capture phase
    }

    // Safari custom select builder
    function buildSafariSelects(scope) {
      if (!isSafari || !scope) return;
      const nativeSelects = scope.querySelectorAll('select.apple-contact-form__select');
      nativeSelects.forEach((select) => {
        if (select.dataset.enhanced) return; // prevent double init
        select.dataset.enhanced = 'true';

        // Hide native select visually (keep it for submission/accessibility)
        select.style.position = 'absolute';
        select.style.opacity = '0';
        select.style.pointerEvents = 'none';
        select.style.width = '100%';

        const wrapper = select.parentElement;
        if (!wrapper) return;

        // Create custom select container
        const custom = document.createElement('div');
        custom.className = 'custom-select';
        custom.setAttribute('data-for', select.id || select.name);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-select__button';
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = '';

        const list = document.createElement('ul');
        list.className = 'custom-select__list';
        list.setAttribute('role', 'listbox');
        list.style.display = 'none';

        // Helper to get label
        const getLabel = (opt) => opt.textContent || opt.value || '';

        const setButtonText = () => {
          const idx = select.selectedIndex;
          if (idx <= 0 || (select.options[idx] && select.options[idx].value === '')) {
            // show no inline text; rely on floating label styling
            button.textContent = '';
            custom.classList.remove('has-value');
            wrapper.classList.remove('has-value');
          } else {
            button.textContent = getLabel(select.options[idx]);
            custom.classList.add('has-value');
            wrapper.classList.add('has-value');
          }
        };

        // Build options (skip empty placeholder if present)
        Array.from(select.options).forEach((opt, index) => {
          if (index === 0 && opt.value === '') return; // skip empty placeholder
          const li = document.createElement('li');
          li.className = 'custom-select__option';
          li.setAttribute('role', 'option');
          li.setAttribute('data-value', opt.value);
          li.textContent = getLabel(opt);
          if (opt.selected) li.setAttribute('aria-selected', 'true');

          li.addEventListener('click', () => {
            // Update native select
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            // Update custom UI
            list
              .querySelectorAll('.custom-select__option[aria-selected="true"]')
              .forEach((n) => n.removeAttribute('aria-selected'));
            li.setAttribute('aria-selected', 'true');
            setButtonText();
            custom.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            list.style.display = 'none';
            // Clear focus and any error, like a valid selection on native select
            wrapper.classList.remove('focused');
            custom.classList.remove('error');
            const msg = wrapper.querySelector('.apple-contact-form__error-message');
            if (msg) msg.style.display = 'none';
          });

          list.appendChild(li);
        });

        custom.appendChild(button);
        custom.appendChild(list);
        const labelEl = wrapper.querySelector('.apple-contact-form__label');
        if (labelEl) {
          wrapper.insertBefore(custom, labelEl);
        } else {
          wrapper.appendChild(custom);
        }

        const updateWrapperValueState = () => {
          const idx = select.selectedIndex;
          const isPlaceholder = idx <= 0 || (select.options[idx] && select.options[idx].value === '');
          wrapper.classList.toggle('has-value', !isPlaceholder);
        };

        // Validate required select and apply error styling to custom UI
        const validateSelect = () => {
          const idx = select.selectedIndex;
          const isPlaceholder = idx <= 0 || (select.options[idx] && select.options[idx].value === '');
          const errorMsg = wrapper.querySelector('.apple-contact-form__error-message');
          if (select.hasAttribute('required') && isPlaceholder) {
            custom.classList.add('error');
            // Keep label centered placeholder style in error (no float)
            wrapper.classList.remove('focused');
            if (errorMsg) errorMsg.style.display = 'flex';
          } else {
            custom.classList.remove('error');
            // If there's no value, allow label to return to default position
            if (!wrapper.classList.contains('has-value')) {
              wrapper.classList.remove('focused');
            }
            if (errorMsg) errorMsg.style.display = 'none';
          }
        };

        // Initialize with empty state
        select.selectedIndex = 0;
        wrapper.classList.remove('has-value', 'focused');
        custom.classList.remove('has-value');
        
        setButtonText();
        updateWrapperValueState();
        // Keep wrapper classes in sync when the hidden select changes
        select.addEventListener('change', () => {
          updateWrapperValueState();
          if (select.selectedIndex > 0) {
            wrapper.classList.remove('focused');
          }
          // Clear custom error when a valid option is set via code
          const idx = select.selectedIndex;
          const isPlaceholder = idx <= 0 || (select.options[idx] && select.options[idx].value === '');
          if (!isPlaceholder) {
            custom.classList.remove('error');
            const msg = wrapper.querySelector('.apple-contact-form__error-message');
            if (msg) msg.style.display = 'none';
          }
        });

        // Toggle list and mirror focus state on wrapper
        const closeList = () => {
          custom.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          list.style.display = 'none';
          if (select.selectedIndex > 0) {
            wrapper.classList.remove('focused');
          }
          validateSelect();
        };
        
        // Close all other open selects when opening this one
        const closeAllOtherSelects = () => {
          document.querySelectorAll('.custom-select.is-open').forEach((otherSelect) => {
            if (otherSelect !== custom) {
              otherSelect.classList.remove('is-open');
              const otherButton = otherSelect.querySelector('.custom-select__button');
              const otherList = otherSelect.querySelector('.custom-select__list');
              if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
              if (otherList) otherList.style.display = 'none';
            }
          });
        };
        
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = custom.classList.contains('is-open');
          
          if (!isOpen) {
            // Close all other dropdowns first
            closeAllOtherSelects();
            custom.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            list.style.display = 'block';
            wrapper.classList.add('focused');
          } else {
            closeList();
          }
        });
        
        button.addEventListener('focus', () => wrapper.classList.add('focused'));
        button.addEventListener('blur', () => {
          setTimeout(() => {
            if (!custom.classList.contains('is-open') && select.selectedIndex <= 0) {
              wrapper.classList.remove('focused');
              validateSelect();
            }
          }, 0);
        });

        // Store event handlers to avoid duplicate listeners
        const documentClickHandler = (e) => {
          // Check if click is outside ANY open select
          if (!custom.contains(e.target) && custom.classList.contains('is-open')) {
            closeList();
          }
        };
        
        const keydownHandler = (e) => {
          // Only handle Escape for this select if it is open
          if (e.key === 'Escape' && custom.classList.contains('is-open')) {
            closeList();
          }
        };
        
        // Add event listeners only once per select
        if (!custom.dataset.hasListeners) {
          custom.dataset.hasListeners = 'true';
          
          // Use capture phase to ensure we catch all clicks
          document.addEventListener('click', documentClickHandler, true);
          document.addEventListener('keydown', keydownHandler);
          
          // Store handlers for potential cleanup
          custom._documentClickHandler = documentClickHandler;
          custom._keydownHandler = keydownHandler;
        }
      });
    }

    // Build one commodity row by cloning the first one
    function createItemRow(index) {
      // Clone the first row if it exists
      const firstRow = itemsContainer.querySelector('.bulk-item');
      if (!firstRow) return null;
      
      const wrapper = firstRow.cloneNode(true);
      wrapper.setAttribute('data-index', String(index));
      
      // Update all name attributes to use the new index
      wrapper.querySelectorAll('[name]').forEach(input => {
        const name = input.getAttribute('name');
        const updatedName = name.replace(/items \d+/, `items ${index}`);
        input.setAttribute('name', updatedName);
      });
      
      // Clear all values
      wrapper.querySelectorAll('input').forEach(input => {
        input.value = '';
        input.classList.remove('error');
        input.style.borderColor = '#d2d2d7';
        input.style.backgroundColor = '#ffffff';
      });
      
      wrapper.querySelectorAll('select').forEach(select => {
        select.selectedIndex = 0;
        select.classList.remove('error');
        select.style.borderColor = '#d2d2d7';
        select.style.backgroundColor = '#ffffff';
        // Remove enhanced flag so it can be rebuilt
        delete select.dataset.enhanced;
        // Reset styles that were applied for custom select
        select.style.position = '';
        select.style.opacity = '';
        select.style.pointerEvents = '';
      });
      
      // Remove custom select UI if present (Safari) - will be rebuilt
      wrapper.querySelectorAll('.custom-select').forEach(customSelect => {
        customSelect.remove();
      });
      
      // Hide all error messages
      wrapper.querySelectorAll('.apple-contact-form__error-message').forEach(error => {
        error.style.display = 'none';
      });
      
      // Hide all other inputs
      wrapper.querySelectorAll('.other-input').forEach(other => {
        other.hidden = true;
      });
      
      // Clear has-value and focused classes
      wrapper.querySelectorAll('.apple-contact-form__field-wrapper').forEach(field => {
        field.classList.remove('has-value', 'focused');
      });
      
      // Add remove button if index > 0
      const removeBtn = wrapper.querySelector('.bulk-item__remove');
      if (index > 0) {
        if (!removeBtn) {
          const newRemoveBtn = document.createElement('button');
          newRemoveBtn.type = 'button';
          newRemoveBtn.className = 'bulk-item__remove';
          newRemoveBtn.setAttribute('aria-label', 'Remove');
          newRemoveBtn.textContent = '×';
          wrapper.insertBefore(newRemoveBtn, wrapper.firstChild);
        }
      } else {
        if (removeBtn) removeBtn.remove();
      }

      attachFieldBehaviors(wrapper);
      return wrapper;
    }

    function attachFieldBehaviors(scope) {
      const inputs = scope.querySelectorAll('.apple-contact-form__input');
      inputs.forEach((input) => {
        if (input.type !== 'hidden' && input.tagName !== 'SELECT') input.setAttribute('placeholder', ' ');
        input.addEventListener('focus', function () {
          this.parentElement.classList.add('focused');
          this.classList.remove('error');
        });
        input.addEventListener('blur', function () {
          if (!this.value) this.parentElement.classList.remove('focused');
        });
        input.addEventListener('input', function () {
          this.parentElement.classList.toggle('has-value', !!this.value);
          // Clear error immediately when user starts typing/selecting
          if (this.value && this.value.trim()) {
            this.classList.remove('error');
            this.style.borderColor = '#d2d2d7';
            this.style.backgroundColor = '#ffffff';
            const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
            if (errorMsg) errorMsg.style.display = 'none';
          }
        });

        // Remove HTML5 validation
        input.addEventListener('invalid', function (e) {
          e.preventDefault();
        });

        // Real-time validation on blur (exactly like apple-style-contact.liquid)
        input.addEventListener('blur', function () {
          const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');

          if (this.hasAttribute('required')) {
            const isEmpty =
              this.tagName === 'SELECT'
                ? this.selectedIndex <= 0 ||
                  (this.selectedIndex === 0 && this.options[0] && this.options[0].value === '')
                : !this.value.trim();
            if (isEmpty) {
              this.style.borderColor = '#FF3B30';
              this.style.backgroundColor = '#FFF5F5';
              this.classList.add('error');
              if (errorMsg) {
                errorMsg.style.display = 'flex';
              }
            } else if (this.type === 'email' && !validateEmail(this.value.trim())) {
              this.style.borderColor = '#FF3B30';
              this.style.backgroundColor = '#FFF5F5';
              this.classList.add('error');
              if (errorMsg) {
                errorMsg.style.display = 'flex';
              }
            } else {
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              this.classList.remove('error');
              if (errorMsg) {
                errorMsg.style.display = 'none';
              }
            }
          }
        });
        input.addEventListener('change', function () {
          if (this.tagName === 'SELECT') {
            const isPlaceholder = this.selectedIndex === 0 && this.options[0] && this.options[0].value === '';
            this.parentElement.classList.toggle('has-value', this.selectedIndex > 0 && !isPlaceholder);
            this.parentElement.classList.remove('focused');

            // Clear error immediately when a valid option is selected
            if (this.selectedIndex > 0 && !isPlaceholder) {
              this.classList.remove('error');
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
              if (errorMsg) errorMsg.style.display = 'none';
            }
          } else {
            this.parentElement.classList.toggle('has-value', !!this.value);
          }
        });
      });

      // Other option reveal
      scope.querySelectorAll('select.js-has-other').forEach((select) => {
        const container = select.parentElement.querySelector('.other-input');
        const toggle = () => {
          // Check for both "other" and "otro" (case insensitive)
          const selectedValue = (select.value || '').toLowerCase();
          const isOther = selectedValue === 'other' || selectedValue === 'otro' || 
                         selectedValue === '{{ "sections.bulk_inquiry_form.commodity_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.bulk_inquiry_form.type_grade_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.bulk_inquiry_form.packaging_type_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.bulk_inquiry_form.desired_weight_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.bulk_inquiry_form.container_type_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.bulk_inquiry_form.payment_terms_options.other" | t | downcase }}';
          
          if (container) {
            container.hidden = !isOther;
            const text = container.querySelector('input');
            if (text) {
              if (isOther) {
                text.setAttribute('required', 'true');
                // Ensure default state is centered label
                container.classList.remove('has-value');
                container.classList.remove('focused');
                text.value = '';
              } else {
                text.removeAttribute('required');
                text.value = '';
                container.classList.remove('has-value');
                container.classList.remove('focused');
              }
            }
          }
        };
        select.addEventListener('change', toggle);
        toggle();
      });

      // Remove row
      const remove = scope.querySelector('.bulk-item__remove');
      if (remove)
        remove.addEventListener('click', () => {
          scope.remove();
          refreshRemoveButtons();
          if (itemsContainer.children.length === 0) {
            addRow();
          }
        });
    }

    // Add new row
    function addRow() {
      const newRow = createItemRow(itemsContainer.children.length);
      if (newRow) {
        itemsContainer.appendChild(newRow);
        // Build Safari custom selects for the new row
        buildSafariSelects(newRow);
      }
    }
    
    // The first row is already in the template, so we just need to set it up
    const firstRow = itemsContainer.querySelector('.bulk-item');
    if (firstRow) {
      attachFieldBehaviors(firstRow);
      buildSafariSelects(firstRow);
    }
    
    addItemBtn.addEventListener('click', addRow);

    function refreshRemoveButtons() {
      const rows = itemsContainer.querySelectorAll('.bulk-item');
      rows.forEach((row, idx) => {
        const btn = row.querySelector('.bulk-item__remove');
        if (btn) btn.style.display = idx === 0 ? 'none' : '';
      });
    }
    refreshRemoveButtons();

    // Ensure top-level inputs (company fields, logistics, etc.) get floating-label behavior
    attachFieldBehaviors(form);

    // Build Safari custom selects for all existing select elements
    buildSafariSelects(form);

    // Special handling for date field to prevent typing but allow calendar
    const dateField = document.getElementById('DesiredDeliveryDate');
    if (dateField) {
      // Set min to today's date (local timezone)
      const pad = (n) => String(n).padStart(2, '0');
      const now = new Date();
      const todayStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
      // try { dateField.setAttribute('min', todayStr); } catch (e) {}

      // Store the original value to prevent changes via typing
      let originalValue = dateField.value;

      // Detect iOS devices (including iPad on iOS 13+)
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      const handleFocus = function () {
        this.parentElement.classList.add('focused');
      };

      const handleBlur = function () {
        if (!this.value) {
          this.parentElement.classList.remove('focused');
        }
      };

      const handleChange = function () {
        if (this.value && this.min && this.value < this.min) {
          this.value = this.min;
        }
        this.parentElement.classList.toggle('has-value', !!this.value);
        originalValue = this.value;
      };

      if (isIOS) {
        // On iOS, rely on the native date picker. Avoid intercepting wrapper/label clicks
        // so that a single tap on the input or label opens the calendar reliably.
        const fieldWrapper = dateField.parentElement;

        // Remove any attributes that might interfere
        dateField.removeAttribute('readonly');

        // Helpful iOS cursor/touch hints
        dateField.style.cursor = 'pointer';
        dateField.style.webkitTapHighlightColor = 'transparent';
        dateField.style.touchAction = 'manipulation';

        if (fieldWrapper) {
          fieldWrapper.style.cursor = 'pointer';
        }

        dateField.addEventListener('focus', handleFocus);
        dateField.addEventListener('blur', handleBlur);
        dateField.addEventListener('change', handleChange);
      } else {
        // Non-iOS devices: keep original validation/typing restrictions
        dateField.addEventListener('focus', handleFocus);
        dateField.addEventListener('blur', handleBlur);
        dateField.addEventListener('change', handleChange);

        // Prevent typing by blocking most keys except navigation and calendar keys
        dateField.addEventListener('keydown', function (e) {
          const allowedKeys = [9, 13, 27, 37, 38, 39, 40, 35, 36, 33, 34];

          if (e.keyCode >= 112 && e.keyCode <= 123) {
            return true;
          }

          if (e.ctrlKey && [65, 67, 86, 88, 90].includes(e.keyCode)) {
            return true;
          }

          if (!allowedKeys.includes(e.keyCode)) {
            e.preventDefault();
            return false;
          }
        });

        dateField.addEventListener('paste', function (e) {
          e.preventDefault();
          return false;
        });

        dateField.addEventListener('input', function (e) {
          const newValue = e.target.value;
          if (newValue && !/^\d{4}-\d{2}-\d{2}$/.test(newValue)) {
            e.target.value = originalValue;
          } else {
            if (e.target.value && e.target.min && e.target.value < e.target.min) {
              e.target.value = e.target.min;
            }
            originalValue = newValue;
          }
        });

        dateField.addEventListener('contextmenu', function (e) {
          e.preventDefault();
          return false;
        });
      }

      // If page loads with a past date, correct it
      if (dateField.value && dateField.min && dateField.value < dateField.min) {
        dateField.value = dateField.min;
        originalValue = dateField.min;
        dateField.parentElement.classList.add('has-value');
      }
    }

    // Simple validation
    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    function validateForm() {
      let ok = true;
      let firstInvalid = null;
      const required = form.querySelectorAll('[required]');
      required.forEach((field) => {
        const errorMsg = field.parentElement.querySelector('.apple-contact-form__error-message');
        const isSelect = field.tagName === 'SELECT';
        const isEmpty = isSelect
          ? field.value === '' ||
            field.selectedIndex <= 0 ||
            (field.options[0] && field.options[0].value === '' && field.selectedIndex === 0)
          : !String(field.value || '').trim();
        if (isEmpty || (field.type === 'email' && !validateEmail(field.value || ''))) {
          field.classList.add('error');
          field.style.borderColor = '#FF3B30';
          field.style.backgroundColor = '#FFF5F5';
          if (errorMsg) errorMsg.style.display = 'flex';
          ok = false;
          if (!firstInvalid) firstInvalid = field;
        } else {
          field.classList.remove('error');
          field.style.borderColor = '#d2d2d7';
          field.style.backgroundColor = '#ffffff';
          if (errorMsg) errorMsg.style.display = 'none';
        }
      });
      if (!ok && firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          try {
            firstInvalid.focus({ preventScroll: true });
          } catch (e) {}
        }, 250);
      }
      return ok;
    }

    if (form && submitBtn) {
      form.setAttribute('novalidate', 'true');
      let submitting = false;
      // Block reCAPTCHA or any click-based handlers when invalid
      submitBtn.addEventListener('click', function (e) {
        if (!validateForm()) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
      form.addEventListener('submit', function (e) {
        if (submitting) {
          e.preventDefault();
          return false;
        }
        if (!validateForm()) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        // Show loading state
        const text = submitBtn.querySelector('.submit-text');
        const load = submitBtn.querySelector('.submit-loading');
        submitting = true;
        submitBtn.disabled = true;
        if (text) text.style.display = 'none';
        if (load) load.style.display = 'inline-block';
        submitBtn.classList.add('loading');

        // Disable view transitions ONLY for the success page navigation
        // This will NOT affect form animations - only the page transition to success screen
        const mainEl = document.querySelector('main.content-for-layout');
        if (mainEl) {
          mainEl.setAttribute('data-page-transition-enabled', 'false');
        }

        // Store flag to disable transitions on success page load only
        try {
          sessionStorage.setItem('vt_disable_next', '1');
        } catch (e) {}

        // Prevent auto scroll jumps and stay at top during navigation
        try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // Allow the form to submit normally - don't prevent default
        // The page will reload and show the success message
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-request-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('ContactRequestForm');
    const addItemBtn = document.getElementById('AddItemButton');
    const itemsContainer = document.getElementById('BulkItems');
    const submitBtn = document.getElementById('contact-submit');

    // Comprehensive form diagnostics
    function runFormDiagnostics() {
      console.group('🔧 FORM DIAGNOSTICS');
      
      // Check if form exists
      if (!form) {
        console.error('❌ Form element not found!');
        return false;
      }
      console.log('✅ Form element found');
      
      // Check form attributes
      console.log('📋 Form attributes:');
      console.log('  - Action:', form.action || 'Not set');
      console.log('  - Method:', form.method || 'Not set');
      console.log('  - Target:', form.target || 'Not set');
      console.log('  - Enctype:', form.enctype || 'Not set');
      
      // Check if form is a Shopify contact form
      if (form.action.includes('/contact') || form.action.includes('contact')) {
        console.log('✅ Form appears to be a Shopify contact form');
      } else {
        console.warn('⚠️ Form action does not appear to be a Shopify contact form');
        console.log('  Expected: /contact or contains "contact"');
        console.log('  Actual:', form.action);
      }
      
      // Check required fields exist
      const requiredFields = ['contact[companyName]', 'contact[email]'];
      requiredFields.forEach(fieldName => {
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (field) {
          console.log(`✅ Required field found: ${fieldName}`);
        } else {
          console.error(`❌ Required field missing: ${fieldName}`);
        }
      });
      
      // Check submit button
      if (submitBtn) {
        console.log('✅ Submit button found');
        console.log('  - Type:', submitBtn.type);
        console.log('  - Disabled:', submitBtn.disabled);
      } else {
        console.error('❌ Submit button not found!');
      }
      
      console.groupEnd();
      return true;
    }
    
    // Check if this is a success page (form was submitted)
    if (window.location.href.includes('contact_posted=true')) {
      console.log('🎉 SUCCESS PAGE DETECTED - Bulk inquiry form was submitted successfully!');
      console.log('📧 Check your email for the contact form submission');
      
      // Check which email the form was sent to
      console.group('📧 EMAIL DESTINATION CHECK');
      console.log('🔍 Checking bulk inquiry form submission details...');
      
      // Try to get form data from URL parameters or session storage
      const urlParams = new URLSearchParams(window.location.search);
      console.log('📋 URL Parameters:', Object.fromEntries(urlParams.entries()));
      
      // Check if we can determine the email destination
      console.log('🏪 Shopify Contact Form Info:');
      console.log('  - Form Action:', form ? form.action : 'Form not found');
      console.log('  - Form Method:', form ? form.method : 'Form not found');
      console.log('  - Current Domain:', window.location.hostname);
      
      // Check for any stored form data
      try {
        const storedData = sessionStorage.getItem('bulk_inquiry_form_data');
        if (storedData) {
          console.log('💾 Stored form data:', JSON.parse(storedData));
        }
      } catch (e) {
        console.log('ℹ️ No stored form data found');
      }
      
      console.log('📬 IMPORTANT: Check your Shopify admin for email settings:');
      console.log('   1. Go to Shopify Admin → Settings → Notifications');
      console.log('   2. Look for "Customer notifications" section');
      console.log('   3. Check "Contact form" notifications');
      console.log('   4. Verify the email address is correct');
      console.log('   5. Check spam/junk folder');
      console.log('   6. Look for emails with subject "Bulk Inquiry Form Submission"');
      
      console.groupEnd();
      
      // Disable form validation on success page
      if (form) {
        form.style.display = 'none';
      }
      
      // Show success message immediately
      const successMessage = document.querySelector('.apple-contact-form__success');
      if (successMessage) {
        successMessage.style.display = 'flex';
        successMessage.style.visibility = 'visible';
        successMessage.style.opacity = '1';
      }
      
      // Ensure page does not auto-scroll down; keep success centered at top
      try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
      try { if (location.hash) { history.replaceState(null, '', location.pathname + location.search); } } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Disable animations and enable centering styles immediately
      document.documentElement.classList.add('disable-all-animations');
      document.body.classList.add('disable-all-animations', 'form-success-showing');

      const mainSuccessEl = document.querySelector('main.content-for-layout');
      if (mainSuccessEl) {
        mainSuccessEl.setAttribute('data-page-transition-enabled', 'false');
        mainSuccessEl.style.viewTransitionName = 'none';
        mainSuccessEl.style.animation = 'none';
        mainSuccessEl.style.transition = 'none';
      }
      
      return; // Exit early on success page
    }

    // Run diagnostics on page load
    runFormDiagnostics();

    // Set minimum date to today for the date input
    const dateInput = document.getElementById('DesiredDeliveryDate');
    if (dateInput) {
      const today = new Date();
      const todayString = today.toISOString().split('T')[0];
      dateInput.setAttribute('min', todayString);
      
      // Safari-friendly: Click wrapper focuses input, let browser handle picker
      const dateWrapper = dateInput.closest('.apple-contact-form__field-wrapper--date');
      if (dateWrapper) {
        dateWrapper.addEventListener('click', function(e) {
          // Only focus if not already clicking the input directly
          if (e.target !== dateInput) {
            dateInput.focus();
            // Trigger click on input for Safari
            dateInput.click();
          }
        });
      }
      
      // Show/hide date format hint and make it clickable
      try {
        const mobileHint = document.getElementById('DesiredDeliveryDateMobileHint');
        if (mobileHint) {
          // Show hint initially, hide when date is selected
          const toggle = () => { 
            mobileHint.style.display = dateInput.value ? 'none' : 'block'; 
          };
          toggle();
          
          // Make hint clickable to open date picker
          mobileHint.addEventListener('click', function(e) {
            e.stopPropagation();
            dateInput.focus();
            dateInput.click();
          });
          
          dateInput.addEventListener('change', toggle);
          dateInput.addEventListener('input', toggle);
        }
      } catch (e) {}
    }

    // Check if success message is present and disable animations immediately
    const successMessage = document.querySelector('.apple-contact-form__success');
    if (successMessage) {
      // Prevent auto scroll jumps and keep page scrollable
      try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
      try { if (location.hash) { history.replaceState(null, '', location.pathname + location.search); } } catch (e) {}
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Add class to HTML element to disable all animations
      document.documentElement.classList.add('disable-all-animations');
      document.body.classList.add('disable-all-animations');
      // Add Safari-compatible class
      document.body.classList.add('form-success-showing');

      // Disable any view transitions that might be active
      const mainEl = document.querySelector('main.content-for-layout');
      if (mainEl) {
        mainEl.setAttribute('data-page-transition-enabled', 'false');
        mainEl.style.viewTransitionName = 'none';
        mainEl.style.animation = 'none';
        mainEl.style.transition = 'none';
      }

      // Force reflow to ensure styles are applied immediately
      void document.body.offsetHeight;

      // Clear the session storage flag
      try {
        sessionStorage.removeItem('vt_disable_next');
      } catch (e) {}

      // Inject style to override all animations
      const styleEl = document.createElement('style');
      styleEl.textContent = `
        * {
          animation: none !important;
          transition: none !important;
          animation-duration: 0s !important;
          transition-duration: 0s !important;
        }
        ::view-transition-old(*),
        ::view-transition-new(*) {
          animation: none !important;
        }
        .apple-contact-form,
        .apple-contact-form__container,
        .apple-contact-form__form,
        .apple-contact-form__success {
          animation: none !important;
          transition: none !important;
          transform: none !important;
          height: auto !important;
          min-height: auto !important;
          max-height: none !important;
        }
      `;
      document.head.appendChild(styleEl);
    }

    // Use native browser dropdowns for all browsers including Safari

    // Use native browser dropdowns for all browsers

    // Build one commodity row by cloning the first one
    function createItemRow(index) {
      // Clone the first row if it exists
      const firstRow = itemsContainer.querySelector('.bulk-item');
      if (!firstRow) return null;
      
      const wrapper = firstRow.cloneNode(true);
      wrapper.setAttribute('data-index', String(index));
      
      // Update all name attributes to use the new index
      wrapper.querySelectorAll('[name]').forEach(input => {
        const name = input.getAttribute('name');
        const updatedName = name.replace(/items \d+/, `items ${index}`);
        input.setAttribute('name', updatedName);
      });
      
      // Clear all values
      wrapper.querySelectorAll('input').forEach(input => {
        input.value = '';
        input.classList.remove('error');
        input.style.borderColor = '#d2d2d7';
        input.style.backgroundColor = '#ffffff';
      });
      
      wrapper.querySelectorAll('select').forEach(select => {
        select.selectedIndex = 0;
        select.classList.remove('error');
        select.style.borderColor = '#d2d2d7';
        select.style.backgroundColor = '#ffffff';
        // Remove enhanced flag so it can be rebuilt
        delete select.dataset.enhanced;
        // Reset styles that were applied for custom select
        select.style.position = '';
        select.style.opacity = '';
        select.style.pointerEvents = '';
      });
      
      // Reset select styles
      wrapper.querySelectorAll('select').forEach(select => {
        select.style.position = '';
        select.style.opacity = '';
        select.style.pointerEvents = '';
      });
      
      // Hide all error messages
      wrapper.querySelectorAll('.apple-contact-form__error-message').forEach(error => {
        error.style.display = 'none';
      });
      
      // Hide all other inputs
      wrapper.querySelectorAll('.other-input').forEach(other => {
        other.hidden = true;
      });
      
      // Clear has-value and focused classes
      wrapper.querySelectorAll('.apple-contact-form__field-wrapper').forEach(field => {
        field.classList.remove('has-value', 'focused');
      });
      
      // Add remove button if index > 0
      const removeBtn = wrapper.querySelector('.bulk-item__remove');
      if (index > 0) {
        if (!removeBtn) {
          const newRemoveBtn = document.createElement('button');
          newRemoveBtn.type = 'button';
          newRemoveBtn.className = 'bulk-item__remove';
          newRemoveBtn.setAttribute('aria-label', 'Remove');
          newRemoveBtn.textContent = '×';
          wrapper.insertBefore(newRemoveBtn, wrapper.firstChild);
        }
      } else {
        if (removeBtn) removeBtn.remove();
      }

      attachFieldBehaviors(wrapper);
      return wrapper;
    }

    function attachFieldBehaviors(scope) {
      const inputs = scope.querySelectorAll('.apple-contact-form__input');
      inputs.forEach((input) => {
        if (input.type !== 'hidden' && input.tagName !== 'SELECT') input.setAttribute('placeholder', ' ');
        input.addEventListener('focus', function () {
          this.parentElement.classList.add('focused');
          this.classList.remove('error');
        });
        input.addEventListener('blur', function () {
          if (!this.value) this.parentElement.classList.remove('focused');
        });
        input.addEventListener('input', function () {
          this.parentElement.classList.toggle('has-value', !!this.value);
          // Clear error immediately when user starts typing/selecting
          if (this.value && this.value.trim()) {
            this.classList.remove('error');
            this.style.borderColor = '#d2d2d7';
            this.style.backgroundColor = '#ffffff';
            const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
            if (errorMsg) errorMsg.style.display = 'none';
          }
        });

        // Mobile date input: keep label visible (floated) when empty
        if (input.type === 'date') {
          // Float label so the field shows its title even when empty on mobile
          const wrapperEl = input.parentElement;
          if (wrapperEl) {
            wrapperEl.classList.add('focused');
          }
          const syncDateState = () => {
            const hasValue = !!(input.value && String(input.value).trim());
            if (!hasValue && wrapperEl) {
              // Keep label floated for visibility
              wrapperEl.classList.add('focused');
              wrapperEl.classList.remove('has-value');
            } else if (wrapperEl) {
              wrapperEl.classList.add('focused');
              wrapperEl.classList.add('has-value');
            }
          };
          input.addEventListener('change', syncDateState);
          input.addEventListener('input', syncDateState);
          syncDateState();
        }

        // Remove HTML5 validation
        input.addEventListener('invalid', function (e) {
          e.preventDefault();
        });

        // Real-time validation on blur
        input.addEventListener('blur', function () {
          // Skip validation for hidden "Other" inputs
          if (this.closest('.other-input') && this.closest('.other-input').hidden) {
            return;
          }
          
          const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');

          if (this.hasAttribute('required')) {
            const isEmpty =
              this.tagName === 'SELECT'
                ? this.selectedIndex <= 0 ||
                  (this.selectedIndex === 0 && this.options[0] && this.options[0].value === '')
                : !this.value.trim();
            
            // Special handling for date fields
            if (this.type === 'date') {
              const selectedDate = new Date(this.value);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              
              if (!this.value) {
                // Required field validation
                this.style.borderColor = '#FF3B30';
                this.style.backgroundColor = '#FFF5F5';
                this.classList.add('error');
                if (errorMsg) {
                  errorMsg.textContent = 'Please select desired delivery date';
                  errorMsg.style.display = 'flex';
                }
              } else if (selectedDate < today) {
                // Past date validation
                this.style.borderColor = '#FF3B30';
                this.style.backgroundColor = '#FFF5F5';
                this.classList.add('error');
                if (errorMsg) {
                  errorMsg.textContent = 'Please select a future date';
                  errorMsg.style.display = 'flex';
                }
              } else {
                // Valid date
                this.style.borderColor = '#d2d2d7';
                this.style.backgroundColor = '#ffffff';
                this.classList.remove('error');
                if (errorMsg) errorMsg.style.display = 'none';
              }
            } else if (isEmpty) {
              this.style.borderColor = '#FF3B30';
              this.style.backgroundColor = '#FFF5F5';
              this.classList.add('error');
              if (errorMsg) {
                errorMsg.style.display = 'flex';
              }
            } else if (this.type === 'email' && !validateEmail(this.value.trim())) {
              this.style.borderColor = '#FF3B30';
              this.style.backgroundColor = '#FFF5F5';
              this.classList.add('error');
              if (errorMsg) {
                errorMsg.style.display = 'flex';
              }
            } else {
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              this.classList.remove('error');
              if (errorMsg) {
                errorMsg.style.display = 'none';
              }
            }
          }
        });

        // Special handling for textarea to prevent gap
        if (input.tagName === 'TEXTAREA') {
          input.addEventListener('focus', function () {
            this.parentElement.classList.add('focused');
            this.classList.remove('error');
            // Ensure no gap appears
            this.style.lineHeight = '1.5';
            this.style.paddingTop = '1.5rem';
          });
          
          input.addEventListener('blur', function () {
            if (!this.value.trim()) {
              this.parentElement.classList.remove('focused');
            }
          });
          
          input.addEventListener('input', function () {
            this.parentElement.classList.toggle('has-value', !!this.value.trim());
            // Clear error immediately when user starts typing
            if (this.value.trim()) {
              this.classList.remove('error');
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
              if (errorMsg) errorMsg.style.display = 'none';
            }
          });
        }

        // Special handling for date input to prevent past dates and validate required
        if (input.type === 'date') {
          const validateDateField = function() {
            const selectedDate = new Date(this.value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
            
              if (!this.value) {
                // Required field validation
                this.classList.add('error');
                this.style.borderColor = '#FF3B30';
                this.style.backgroundColor = '#FFF5F5';
                if (errorMsg) {
                  errorMsg.textContent = 'Please select desired delivery date';
                  errorMsg.style.display = 'flex';
                }
            } else if (selectedDate < today) {
              // Past date validation
              this.classList.add('error');
              this.style.borderColor = '#FF3B30';
              this.style.backgroundColor = '#FFF5F5';
              if (errorMsg) {
                errorMsg.textContent = 'Please select a future date';
                errorMsg.style.display = 'flex';
              }
            } else {
              // Valid date
              this.classList.remove('error');
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              if (errorMsg) errorMsg.style.display = 'none';
            }
          };
          
          input.addEventListener('change', validateDateField);
          input.addEventListener('input', validateDateField);
        }
        input.addEventListener('change', function () {
          if (this.tagName === 'SELECT') {
            const isPlaceholder = this.selectedIndex === 0 && this.options[0] && this.options[0].value === '';
            this.parentElement.classList.toggle('has-value', this.selectedIndex > 0 && !isPlaceholder);
            // Keep label fully floated when a valid option is selected
            if (this.selectedIndex > 0 && !isPlaceholder) {
              this.parentElement.classList.add('focused');
            } else {
              this.parentElement.classList.remove('focused');
            }

            // Clear error immediately when a valid option is selected
            if (this.selectedIndex > 0 && !isPlaceholder) {
              this.classList.remove('error');
              this.style.borderColor = '#d2d2d7';
              this.style.backgroundColor = '#ffffff';
              const errorMsg = this.parentElement.querySelector('.apple-contact-form__error-message');
              if (errorMsg) errorMsg.style.display = 'none';
            }
          } else {
            this.parentElement.classList.toggle('has-value', !!this.value);
          }
        });
      });

      // Improve native select reliability on some mobile browsers
      scope.querySelectorAll('select.apple-contact-form__select').forEach((sel) => {
        sel.addEventListener('touchstart', function () {
          try { this.focus({ preventScroll: true }); } catch (e) {}
        }, { passive: true });
      });

      // Other option reveal
      scope.querySelectorAll('select.js-has-other').forEach((select) => {
        const container = select.parentElement.querySelector('.other-input');
        const toggle = () => {
          // Check for both "other" and "otro" (case insensitive)
          const selectedValue = (select.value || '').toLowerCase();
          const isOther = selectedValue === 'other' || selectedValue === 'otro' || 
                         selectedValue === '{{ "sections.contact_request_form.commodity_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.contact_request_form.type_grade_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.contact_request_form.packaging_type_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.contact_request_form.desired_weight_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.contact_request_form.container_type_options.other" | t | downcase }}' ||
                         selectedValue === '{{ "sections.contact_request_form.payment_terms_options.other" | t | downcase }}';
          
          if (container) {
            container.hidden = !isOther;
            const text = container.querySelector('input');
            if (text) {
              if (isOther) {
                text.setAttribute('required', 'true');
                // Ensure default state is centered label
                container.classList.remove('has-value');
                container.classList.remove('focused');
                text.value = '';
              } else {
                text.removeAttribute('required');
                text.value = '';
                container.classList.remove('has-value');
                container.classList.remove('focused');
                // Clear any error state when hiding
                text.classList.remove('error');
                text.style.borderColor = '#d2d2d7';
                text.style.backgroundColor = '#ffffff';
                const errorMsg = container.querySelector('.apple-contact-form__error-message');
                if (errorMsg) errorMsg.style.display = 'none';
              }
            }
          }
        };
        select.addEventListener('change', toggle);
        toggle();
      });

      // Remove row
      const remove = scope.querySelector('.bulk-item__remove');
      if (remove)
        remove.addEventListener('click', () => {
          scope.remove();
          refreshRemoveButtons();
          if (itemsContainer.children.length === 0) {
            addRow();
          }
        });
    }

    // Add new row
    function addRow() {
      const newRow = createItemRow(itemsContainer.children.length);
      if (newRow) {
        itemsContainer.appendChild(newRow);
      }
    }
    
    // The first row is already in the template, so we just need to set it up
    const firstRow = itemsContainer.querySelector('.bulk-item');
    if (firstRow) {
      attachFieldBehaviors(firstRow);
    }
    
    addItemBtn.addEventListener('click', addRow);

    function refreshRemoveButtons() {
      const rows = itemsContainer.querySelectorAll('.bulk-item');
      rows.forEach((row, idx) => {
        const btn = row.querySelector('.bulk-item__remove');
        if (btn) btn.style.display = idx === 0 ? 'none' : '';
      });
    }
    refreshRemoveButtons();

    // Ensure top-level inputs get floating-label behavior
    attachFieldBehaviors(form);

    // Simple validation
    function validateEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    
    function validateForm() {
      let ok = true;
      let firstInvalid = null;
      const required = form.querySelectorAll('[required]');
      required.forEach((field) => {
        // Skip validation for hidden "Other" inputs
        if (field.closest('.other-input') && field.closest('.other-input').hidden) {
          return;
        }
        
        const errorMsg = field.parentElement.querySelector('.apple-contact-form__error-message');
        const isSelect = field.tagName === 'SELECT';
        const isTextarea = field.tagName === 'TEXTAREA';
        const isEmpty = isSelect
          ? field.value === '' ||
            field.selectedIndex <= 0 ||
            (field.options[0] && field.options[0].value === '' && field.selectedIndex === 0)
          : !String(field.value || '').trim();
        
        // Check if date is in the past or empty (for required date fields)
        const isPastDate = field.type === 'date' && field.value && new Date(field.value) < new Date().setHours(0,0,0,0);
        const isEmptyDate = field.type === 'date' && field.hasAttribute('required') && !field.value;
        
        if (isEmpty || (field.type === 'email' && !validateEmail(field.value || '')) || isPastDate || isEmptyDate) {
          field.classList.add('error');
          field.style.borderColor = '#FF3B30';
          field.style.backgroundColor = '#FFF5F5';
          if (errorMsg) errorMsg.style.display = 'flex';
          ok = false;
          if (!firstInvalid) firstInvalid = field;
        } else {
          field.classList.remove('error');
          field.style.borderColor = '#d2d2d7';
          field.style.backgroundColor = '#ffffff';
          if (errorMsg) errorMsg.style.display = 'none';
        }
      });
      if (!ok && firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          try {
            firstInvalid.focus({ preventScroll: true });
          } catch (e) {}
        }, 250);
      }
      return ok;
    }

    if (form && submitBtn) {
      form.setAttribute('novalidate', 'true');
      let submitting = false;
      
      // Enhanced debugging function
      function debugFormSubmission(formData, error = null) {
        console.group('🔍 CONTACT FORM DEBUG INFO');
        console.log('📧 Form Type: Bulk Inquiry Form');
        console.log('⏰ Timestamp:', new Date().toISOString());
        console.log('🌐 Current URL:', window.location.href);
        console.log('📱 User Agent:', navigator.userAgent);
        
        if (error) {
          console.error('❌ ERROR:', error);
        }
        
        console.log('📋 Form Data:');
        for (let [key, value] of formData.entries()) {
          console.log(`  ${key}: ${value}`);
        }
        
        // Check for required fields
        const requiredFields = ['contact[companyName]', 'contact[email]', 'contact[items 0 commodity]'];
        const missingFields = [];
        requiredFields.forEach(field => {
          if (!formData.get(field) || formData.get(field).trim() === '') {
            missingFields.push(field);
          }
        });
        
        if (missingFields.length > 0) {
          console.warn('⚠️ Missing required fields:', missingFields);
        } else {
          console.log('✅ All required fields present');
        }
        
        // Check email format
        const email = formData.get('contact[email]');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailRegex.test(email)) {
          console.warn('⚠️ Invalid email format:', email);
        } else if (email) {
          console.log('✅ Email format valid:', email);
        }
        
        console.groupEnd();
      }
      
      // Block reCAPTCHA or any click-based handlers when invalid
      submitBtn.addEventListener('click', function (e) {
        console.log('🖱️ Submit button clicked');
        if (!validateForm()) {
          console.warn('❌ Form validation failed on click');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        console.log('✅ Form validation passed on click');
      });
      
      form.addEventListener('submit', function (e) {
        console.log('📤 Form submit event triggered');
        
        if (submitting) {
          console.warn('⚠️ Form already submitting, preventing duplicate submission');
          e.preventDefault();
          return false;
        }
        
        if (!validateForm()) {
          console.error('❌ Form validation failed on submit');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        console.log('✅ Form validation passed, proceeding with submission');

        // Check if this is a reCAPTCHA reload (URL contains contact_posted=true)
        if (window.location.href.includes('contact_posted=true')) {
          console.log('🔄 Detected reCAPTCHA reload - form was already submitted');
          return; // Let the page show success message
        }

        // Show loading state
        const text = submitBtn.querySelector('.submit-text');
        const load = submitBtn.querySelector('.submit-loading');
        submitting = true;
        submitBtn.disabled = true;
        if (text) text.style.display = 'none';
        if (load) load.style.display = 'inline-block';
        submitBtn.classList.add('loading');

        // Disable view transitions ONLY for the success page navigation
        const mainEl = document.querySelector('main.content-for-layout');
        if (mainEl) {
          mainEl.setAttribute('data-page-transition-enabled', 'false');
        }

        // Store flag to disable transitions on success page load only
        try {
          sessionStorage.setItem('vt_disable_next', '1');
        } catch (e) {
          console.warn('⚠️ Could not set session storage:', e);
        }

        // Prevent auto scroll jumps and stay at top during navigation
        try { if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; } } catch (e) {}
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        // Debug form submission
        const formData = new FormData(form);
        debugFormSubmission(formData);
        
        // Store form data for debugging
        try {
          const formDataObj = {};
          for (let [key, value] of formData.entries()) {
            formDataObj[key] = value;
          }
          sessionStorage.setItem('bulk_inquiry_form_data', JSON.stringify(formDataObj));
          console.log('💾 Form data stored for debugging');
        } catch (e) {
          console.warn('⚠️ Could not store form data:', e);
        }
        
        // Check if form action is correct
        console.log('🔗 Form action:', form.action);
        console.log('📝 Form method:', form.method);
        console.log('🎯 Form target:', form.target);
        
        // Log the email address being used
        const emailField = form.querySelector('input[name="contact[email]"]');
        if (emailField) {
          console.log('📧 Form will be sent to:', emailField.value);
        }
        
        // Add error handling for form submission
        form.addEventListener('error', function(e) {
          console.error('❌ Form submission error:', e);
          debugFormSubmission(new FormData(form), e);
        });
        
        // Monitor for any JavaScript errors during submission
        window.addEventListener('error', function(e) {
          console.error('❌ JavaScript error during form submission:', e);
        });
        
        console.log('📧 Form should now send email to registered address');
        console.log('💡 Check your Shopify admin → Settings → Notifications for email settings');
        console.log('📬 Check spam/junk folder for emails from Shopify');
        
        // Add global test function for manual testing
        window.testContactForm = function() {
          console.log('🧪 MANUAL FORM TEST');
          runFormDiagnostics();
          debugFormSubmission(new FormData(form));
          
          // Test form submission without actually submitting
          console.log('🔍 Testing form data collection...');
          const testData = new FormData(form);
          console.log('📊 Test data collected successfully');
          
          // Check if all required data is present
          const hasCompany = testData.get('contact[companyName]');
          const hasEmail = testData.get('contact[email]');
          const hasCommodity = testData.get('contact[items 0 commodity]');
          
          if (hasCompany && hasEmail && hasCommodity) {
            console.log('✅ All test data present - form should work');
          } else {
            console.warn('⚠️ Missing test data - fill out form first');
          }
        };
        
        console.log('💡 Run window.testContactForm() in console to test form manually');
        
        // Add email delivery test function
        window.testEmailDelivery = function() {
          console.group('🧪 EMAIL DELIVERY TEST');
          console.log('📧 Testing email delivery configuration...');
          
          // Check if we can find any email configuration
          console.log('🔍 Checking form configuration:');
          console.log('  - Form action:', form.action);
          console.log('  - Form method:', form.method);
          console.log('  - Current domain:', window.location.hostname);
          
          // Check if this is a Shopify contact form
          if (form.action.includes('/contact')) {
            console.log('✅ Form is using Shopify contact endpoint');
            console.log('📬 Emails should be sent to your Shopify admin notification settings');
            console.log('🔧 To configure: Settings → Notifications → Customer notifications → Contact form');
          } else {
            console.warn('⚠️ Form action does not appear to be Shopify contact form');
          }
          
          console.log('📋 Troubleshooting checklist:');
          console.log('  1. ✅ Form submits successfully (confirmed)');
          console.log('  2. ❓ Contact form notifications enabled in Shopify admin');
          console.log('  3. ❓ Email address configured in notification settings');
          console.log('  4. ❓ Check spam/junk folder');
          console.log('  5. ❓ Try different email address (not role-based)');
          
          console.groupEnd();
        };
        
        console.log('💡 Run window.testEmailDelivery() to check email configuration');
        
        // Don't prevent default - let reCAPTCHA handle the submission
        console.log('🤖 Allowing reCAPTCHA to handle form submission');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order-advanced"] && !Shopify.designMode) return;
  try {
    
// Set placeholders immediately to prevent Safari modification
(function() {
  const inputs = document.querySelectorAll('.apple-track-order__input');
  inputs.forEach(input => {
    input.placeholder = ' ';
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  const inputs = document.querySelectorAll('.apple-track-order__input');
  const form = document.getElementById('trackOrderForm');
  const submitButton = document.getElementById('track-submit-button');
  const resultsDiv = document.getElementById('trackingResults');
  const errorDiv = document.getElementById('errorMessage');
  const trackingContent = document.getElementById('trackingContent');
  const errorText = document.getElementById('errorText');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  if (isSafari) {
    const root = document.querySelector('.apple-track-order');
    if (root) root.classList.add('is-safari');
    
    // Disable hover effects on inputs for Safari
    inputs.forEach(input => {
      input.addEventListener('mouseenter', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
      
      input.addEventListener('mouseleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });
  }
  
  // Cache for authentication token
  let authToken = null;
  let tokenExpiry = null;
  
  // Initialize floating labels
  inputs.forEach(input => {
    // Set placeholder to empty to prevent default browser behavior
    input.setAttribute('placeholder', ' ');
    
    // Handle focus events
    input.addEventListener('focus', function() {
      this.parentElement.classList.add('focused');
      // Remove error state on focus
      this.classList.remove('error');
    });
    
    // Handle blur events
    input.addEventListener('blur', function() {
      if (!this.value) {
        this.parentElement.classList.remove('focused');
      }
    });
    
    // Handle input events for real-time validation
    input.addEventListener('input', function() {
      this.parentElement.classList.toggle('has-value', !!this.value);
      // Clear error immediately when user starts typing
      if (this.value && this.value.trim()) {
        this.classList.remove('error');
        this.style.borderColor = '#d2d2d7';
        this.style.backgroundColor = '#ffffff';
        const errorMsg = this.parentElement.querySelector('.apple-track-order__error-message');
        if (errorMsg) errorMsg.style.display = 'none';
      }
    });
    
    // Initialize state
    if (input.value && input.value !== '') {
      input.parentElement.classList.add('has-value');
    }
  });
  
  // Validate form fields
  function validateForm() {
    const awbField = document.getElementById('awbNumber');
    const errorMsg = awbField.parentElement.querySelector('.apple-track-order__error-message');
    let isValid = true;
    
    // Check if AWB field is empty
    if (!awbField.value.trim()) {
      awbField.style.borderColor = '#FF3B30';
      awbField.style.backgroundColor = '#FFF5F5';
      awbField.classList.add('error');
      if (errorMsg) {
        errorMsg.style.display = 'flex';
      }
      isValid = false;
    } else {
      awbField.style.borderColor = '#d2d2d7';
      awbField.style.backgroundColor = '#ffffff';
      awbField.classList.remove('error');
      if (errorMsg) {
        errorMsg.style.display = 'none';
      }
    }
    
    return isValid;
  }
  
  // Real-time validation on blur
  inputs.forEach(input => {
    input.addEventListener('invalid', function(e) {
      e.preventDefault();
    });
    
    input.addEventListener('blur', function() {
      const errorMsg = this.parentElement.querySelector('.apple-track-order__error-message');
      
      if (this.hasAttribute('required') && !this.value.trim()) {
        this.style.borderColor = '#FF3B30';
        this.style.backgroundColor = '#FFF5F5';
        this.classList.add('error');
        if (errorMsg) {
          errorMsg.style.display = 'flex';
        }
      } else {
        this.style.borderColor = '#d2d2d7';
        this.style.backgroundColor = '#ffffff';
        this.classList.remove('error');
        if (errorMsg) {
          errorMsg.style.display = 'none';
        }
      }
    });
  });
  
  // Handle form submission with loading state
  if (form && submitButton) {
    // Disable HTML5 validation
    form.setAttribute('novalidate', 'true');
    
    let submitting = false;
    
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      if (submitting) return false;
      
      // Validate form before submission
      if (!validateForm()) {
        return false;
      }
      
      const awbNumber = document.getElementById('awbNumber').value.trim();
      
      const submitText = submitButton.querySelector('.submit-text');
      const submitLoading = submitButton.querySelector('.submit-loading');
      
      // Show loading state
      submitting = true;
      submitButton.disabled = true;
      submitText.style.display = 'none';
      submitLoading.style.display = 'inline-block';
      submitButton.classList.add('loading');
    
    // Hide previous results/errors
    resultsDiv.style.display = 'none';
    errorDiv.style.display = 'none';
    
    try {
      // Get ShipRocket API credentials from theme settings
      const apiUserEmail = '{{ settings.shiprocket_api_user_email }}';
      const apiUserPassword = '{{ settings.shiprocket_api_user_password }}';
      
      if (!apiUserEmail || !apiUserPassword) {
        // No API credentials, show alternative tracking
        showTrackingAlternative(awbNumber);
        return;
      }
      
      // Attempt direct API call
      const trackingData = await callShipRocketAPI(awbNumber, apiUserEmail, apiUserPassword);
      
      if (trackingData && trackingData.tracking_data) {
        displayTrackingResults(trackingData.tracking_data, trackingData);
      } else {
        // Fallback to alternative tracking
        showTrackingAlternative(awbNumber);
      }
      
    } catch (error) {
      console.error('API call failed:', error);
      // Always fallback to alternative tracking on any error
      showTrackingAlternative(awbNumber);
    } finally {
      // Reset button state
      submitText.style.display = 'inline-block';
      submitLoading.style.display = 'none';
      submitButton.disabled = false;
      submitButton.classList.remove('loading');
      submitting = false;
    }
  });
  }
  
  // Direct ShipRocket API call function
  async function callShipRocketAPI(awbNumber, email, password) {
    try {
      // Step 1: Authenticate with ShipRocket
      const authResponse = await fetch('https://apiv2.shiprocket.in/v1/external/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });
      
      if (!authResponse.ok) {
        const errorData = await authResponse.json().catch(() => ({}));
        throw new Error(errorData.message || `Authentication failed: ${authResponse.status}`);
      }
      
      const authData = await authResponse.json();
      const token = authData.token;
      
      if (!token) {
        throw new Error('Failed to get authentication token');
      }
      
      // Step 2: Track by AWB
      return await trackByAwb(awbNumber, token);
      
    } catch (error) {
      // Log the error but don't throw - let the caller handle fallback
      console.error('ShipRocket API Error:', error.message);
      throw error;
    }
  }
  
  async function trackByAwb(awbNumber, token) {
    const response = await fetch(`https://apiv2.shiprocket.in/v1/external/courier/track/awb/${awbNumber}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`AWB tracking failed: ${response.status}`);
    }
    
    return await response.json();
  }
  
  
  function displayTrackingResults(trackingData, fullResponse) {
    // Handle different response structures from ShipRocket API
    let shipmentInfo = {};
    let activities = [];
    
    // Extract shipment information
    if (trackingData.shipment_track && trackingData.shipment_track.length > 0) {
      shipmentInfo = trackingData.shipment_track[0];
    }
    
    // Extract tracking activities
    if (trackingData.shipment_track_activities && trackingData.shipment_track_activities.length > 0) {
      activities = trackingData.shipment_track_activities;
    }
    
    let html = `
      <div class="tracking-summary">
        <div class="tracking-info-grid">
          <div class="info-item">
            <span class="info-label">AWB Number:</span>
            <span class="info-value">${shipmentInfo.awb_code || 'N/A'}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Current Status:</span>
            <span class="info-value status-${(shipmentInfo.current_status || 'unknown').toLowerCase().replace(/\s+/g, '-')}">${shipmentInfo.current_status || 'Status not available'}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Courier Partner:</span>
            <span class="info-value">${shipmentInfo.courier_name || 'Not assigned'}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Expected Delivery:</span>
            <span class="info-value">${shipmentInfo.edd ? new Date(shipmentInfo.edd).toLocaleDateString() : 'Not available'}</span>
          </div>
        </div>
      </div>
    `;
    
    // Add order details if available
    if (shipmentInfo.order_id || shipmentInfo.channel_order_id) {
      html += `
        <div class="order-details">
          <h4>Order Details</h4>
          <div class="tracking-info-grid">
            ${shipmentInfo.order_id ? `
              <div class="info-item">
                <span class="info-label">Order ID:</span>
                <span class="info-value">${shipmentInfo.order_id}</span>
              </div>
            ` : ''}
            ${shipmentInfo.channel_order_id ? `
              <div class="info-item">
                <span class="info-label">Reference Order ID:</span>
                <span class="info-value">${shipmentInfo.channel_order_id}</span>
              </div>
            ` : ''}
            ${shipmentInfo.pickup_location ? `
              <div class="info-item">
                <span class="info-label">Pickup Location:</span>
                <span class="info-value">${shipmentInfo.pickup_location}</span>
              </div>
            ` : ''}
            ${shipmentInfo.delivered_date ? `
              <div class="info-item">
                <span class="info-label">Delivered Date:</span>
                <span class="info-value">${new Date(shipmentInfo.delivered_date).toLocaleString()}</span>
              </div>
            ` : ''}
          </div>
        </div>
      `;
    }
    
    // Add tracking timeline if activities are available
    if (activities && activities.length > 0) {
      html += `
        <div class="tracking-timeline">
          <h4>Tracking History</h4>
          <div class="timeline">
      `;
      
      // Sort activities by date (newest first)
      const sortedActivities = activities.sort((a, b) => new Date(b.date) - new Date(a.date));
      
      sortedActivities.forEach((activity, index) => {
        const activityDate = new Date(activity.date);
        const isRecent = index === 0; // Most recent activity
        
        html += `
          <div class="timeline-item ${isRecent ? 'current' : ''}">
            <div class="timeline-marker"></div>
            <div class="timeline-content">
              <div class="timeline-status">${activity.activity || 'Status update'}</div>
              <div class="timeline-location">${activity.location || 'Location not specified'}</div>
              <div class="timeline-date">${activityDate.toLocaleString()}</div>
              ${activity.sr_status_label ? `<div class="timeline-label">${activity.sr_status_label}</div>` : ''}
            </div>
          </div>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    } else {
      html += `
        <div class="no-tracking-history">
          <p>No detailed tracking history available yet.</p>
        </div>
      `;
    }
    
    trackingContent.innerHTML = html;
    resultsDiv.style.display = 'block';
    resultsDiv.scrollIntoView({ behavior: 'smooth' });
  }
  
  function showTrackingAlternative(awbNumber) {
    let html = `
      <div class="tracking-summary">
        <div class="alternative-tracking">
          <h4>📦  Track Your Shipment</h4>
          <div class="awb-display">
            <p style="margin-bottom:0px;">Your AWB/Tracking Number: <br><span class="awb-number">${awbNumber}</span></p>
            <button class="copy-awb" onclick="copyToClipboard('${awbNumber}')">Copy AWB</button>
          </div>
          
          <div class="tracking-options">
            <div class="tracking-option primary">
              <h5>Quick Track - Popular Couriers</h5>
              <p>Click on your courier partner to track directly:</p>
              <div class="courier-links">
                <a href="https://www.bluedart.com/web/guest/trackdartresult?trackFor=0&trackNo=${awbNumber}" target="_blank" class="courier-link blue-dart">Blue Dart</a>
                <a href="https://www.dtdc.in/tracking/consignment-tracking" target="_blank" class="courier-link dtdc">DTDC</a>
                <a href="https://www.delhivery.com/track/package/${awbNumber}" target="_blank" class="courier-link delhivery">Delhivery</a>
                <a href="https://www.ekart.in/track" target="_blank" class="courier-link ekart">Ekart</a>
                <a href="https://shiprocket.in/shipment-tracking/" target="_blank" class="courier-link shiprocket">ShipRocket</a>
                <a href="https://www.fedex.com/en-in/tracking.html" target="_blank" class="courier-link fedex">FedEx</a>
              </div>
            </div>
            
            <div class="tracking-option">
              <h5>Universal Tracking Services</h5>
              <p>These services can track multiple courier partners:</p>
              <div class="universal-links">
                <a href="https://www.trackingmore.com/track/en/${awbNumber}" target="_blank" class="universal-link">TrackingMore</a>
                <a href="https://www.17track.net/en/track#nums=${awbNumber}" target="_blank" class="universal-link">17Track</a>
                <a href="https://www.packagetrackr.com/track/${awbNumber}" target="_blank" class="universal-link">PackageTrackr</a>
              </div>
            </div>
            
            <div class="tracking-option">
              <h5>Need Help?</h5>
              <p>Contact our support team with your AWB details:</p>
              <div class="contact-details">
                <div class="detail-item">
                  <span class="detail-label">AWB Number:</span>
                  <span class="detail-value">${awbNumber}</span>
                </div>
              </div>
              <button class="contact-btn" onclick="window.location.href='/pages/contact'">Contact Support</button>
            </div>
          </div>
        </div>
      </div>
    `;
    
    trackingContent.innerHTML = html;
    resultsDiv.style.display = 'block';
    resultsDiv.scrollIntoView({ behavior: 'smooth' });
  }
  
  
  function showError(message) {
    errorText.textContent = message;
    errorDiv.style.display = 'block';
    errorDiv.scrollIntoView({ behavior: 'smooth' });
  }
  
  // Utility function to copy text to clipboard
  window.copyToClipboard = function(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        showCopySuccess();
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        showCopySuccess();
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      document.body.removeChild(textArea);
    }
  }
  
  function showCopySuccess() {
    const copyBtn = document.querySelector('.copy-awb');
    if (copyBtn) {
      const originalText = copyBtn.textContent;
      copyBtn.textContent = '✓ Copied!';
      copyBtn.style.background = '#22c55e';
      setTimeout(() => {
        copyBtn.textContent = originalText;
        copyBtn.style.background = '';
      }, 2000);
    }
  }
  
  // Add subtle hover effects - disabled for Safari to prevent content shifting
  if (!isSafari) {
    inputs.forEach(input => {
      input.addEventListener('mouseenter', function() {
        if (!this.matches(':focus') && !this.classList.contains('error')) {
          this.style.borderColor = '#666666';
          this.style.transform = 'translateY(-1px)';
        }
      });
      
      input.addEventListener('mouseleave', function() {
        if (!this.matches(':focus') && !this.classList.contains('error')) {
          this.style.borderColor = '#d2d2d7';
          this.style.transform = 'translateY(0)';
        }
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
